<template>
  <div class="generic-calculadora-parameters py-3 px-5">
    <v-fade-transition>
      <v-overlay v-if="cargandoTabZona" absolute>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-overlay>
    </v-fade-transition>
    <!-- 
      Fila encargada de técnicas, grupos de técnicas y el selector de colores
    -->

    <v-row v-if="isStaminaModel">
      <v-col>
        <span class="description-zone">
          {{ formatDescription(zona.Posicion) }}
        </span>
      </v-col>
    </v-row>

    <v-row v-if="imgDesignZone" class="container-actual-design">
      <v-col>
        <span class="design-actual-zone">
        {{$t("general.desingActualZone")}}
      </span>
      <div class="container-img-actual-zone" > 
        <v-btn icon class="delete-icon" @click="removeCustomDesign">
          <v-icon >$fi-x-circle</v-icon>
        </v-btn>
        <v-img contain class="img-actual-zone" :src="imgDesignZone" />
      </div>
    </v-col>
    </v-row>

    <v-row>
      <!-- Selector principal de técnica -->
      <v-col class="pl-8" :md="infoTecnicaSeleccionada.colores ? 8 : 12">
        <span class="litle-head-title">
          {{ $t("general.Seleccione una técnica para marcar") }}
        </span>
        <v-select
          v-model="tecnicaSeleccionada"
          :disabled="loadingCarrito"
          :items="groupedTecnicasArray"
          item-text="label"
          item-value="valueTecnica"
          label=""
          hide-details="true"
          class="mb-3 pt-0"
        ></v-select>
      </v-col>

      <!-- Selector de colores -->
      <v-col
        v-if="infoTecnicaSeleccionada.colores"
        :md="hasGroupedTecnicaSelected ? 4 : 4"
      >
        <span class="litle-head-title">
          {{ $t("configuration.Serigrafia.Colores") }}
        </span>
        <v-select
          v-model="params.colores"
          :items="coloresDisponibles"
          :color="logoNumColor && logoNumColor != params.colores ? 'warning' : 'primary darken-2'"
          :prepend-inner-icon="logoNumColor && logoNumColor != params.colores ? 'mdi-alert' : 'mdi-format-color-fill'"
          label=""
          :hide-details="!logoNumColor || logoNumColor == params.colores"
          :error="!!logoNumColor && logoNumColor != params.colores"
          :error-messages="logoNumColor && logoNumColor != params.colores ? $t('errores.alert.NotSameNumColorThanLogo') : ''"
          class="mb-3 pt-0 color-selector"
        >
          <template #item="{ item, attrs, on }">
            <v-list-item
            class="color-list"
              v-bind="attrs"
              :class="logoNumColor && item !== logoNumColor ? 'error-option' : 'correct-option'"
              v-on="on"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ item }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-row v-if="showSelectSpecificTecnicaOfGroup">
      <!-- Selector de técnica secundaría, si tenemos un grupo de técnicas seleccionado (Numeros/TransferStm...) -->
      <v-col cols="12" md="12">
        <!-- <span class="litle-head-title">varicion</span> -->
        <v-select
          v-model="specificTecnicaSeleccionadOfGroup"
          :disabled="loadingCarrito"
          :items="selectedGroupedTecnica"
          item-text="label"
          item-value="valueTecnica"
          label=""
          hide-details="true"
          class="mb-3 pt-0"
        ></v-select>
      </v-col>
    </v-row>

    <v-row v-if="true">
      <v-col>
        <div class="litle-head-alert">
          <span>{{ $t("configuration.simpleMaxSizeMessage") }}:</span>
          <br />
          <span>
            <template
              v-if="infoTecnicaSeleccionada.tamano && !seEnvianMetrosLineales"
            >
              {{ actualMaxValidSize.text }} ({{
                actualMaxValidSize.cm2MaxSize
              }}mm)
            </template>
            <template v-else-if="infoTecnicaSeleccionada.idTamImpresion">
              {{ actualMaxValidSizeImpresionDirecta.text }}
            </template>
            <template v-else-if="infoTecnicaSeleccionada.tamanocm2Digital">
              {{ maxValidSizeDigital?.upperValue }}cm2
            </template>
            <template v-else-if="infoTecnicaSeleccionada.tamanoCm2Doming">
              {{ maxValidSizeDoming.cm2 }}cm2 ({{
                maxValidSizeDoming.cm2MaxSize
              }}mm)
            </template>
            <template v-else-if="infoTecnicaSeleccionada.tamanoCm2 && infoTecnicaSeleccionada.valueTecnica == 'Dtf3d'">
              {{ maxSizeForTamanoCm2.Area > 50 ? 50 : maxSizeForTamanoCm2.Area }}cm2
            </template>
            <template v-else-if="infoTecnicaSeleccionada.tamanoCm2">
              {{ maxSizeForTamanoCm2.Area }}cm2 ({{
                maxSizeForTamanoCm2.Ancho
              }}x{{ maxSizeForTamanoCm2.Alto }}mm)
            </template>
            <template v-else>{{ actualMaxValidSize.cm2MaxSize }}mm</template>
          </span>
        </div>
      </v-col>
    </v-row>

    <!-- Selector de altura mediante una selección de opciones -->
    <v-row v-if="infoTecnicaSeleccionada.maxHeightSelect">
      <v-col>
        <span class="litle-head-title">
          {{ $t($t("configuration.Transfer.Alto")) }}
        </span>
        <v-select
          v-model="params.maxHeightSelect"
          :items="maxHeightSelectOption"
          color="primary darken-2"
          prepend-inner-icon="mdi-tape-measure"
          label=""
          hide-details="true"
          class="mb-3 pt-0"
        ></v-select>
      </v-col>
    </v-row>

    <!-- Selector de tipo de color -->
    <v-row v-if="infoTecnicaSeleccionada.typeColor">
      <v-col cols="12">
        <!-- <span class="litle-head-title">typeColor</span> -->
        <v-select
          v-model="params.typeColor"
          hide-details="true"
          prepend-inner-icon="mdi-format-color-fill"
          color="primary darken-2"
          :items="filteredOptions"
          item-text="Label"
          item-value="Type"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <!-- selector de tamano -->
      <v-col v-if="infoTecnicaSeleccionada.tamano && !seEnvianMetrosLineales">
        <!-- <div class="litle-head-alert">
          {{ $t("configuration.El tamaño máximo para esta combinación de tallas es") }}: <br>{{  actualMaxValidSize.text }} ({{actualMaxValidSize.cm2MaxSize}}mm)
        </div> -->
        <span class="litle-head-title">
          {{ $t("configuration.Serigrafia.Tamaño del estampado") }}
        </span>
        <v-select
          v-model="params.tamano"
          :items="tamanosArray"
          label=""
          outlined
          color="primary darken-2"
          prepend-inner-icon="mdi-tape-measure"
          hide-details="true"
          class="pt-0"
          @change="actualGetMedidasByTamano"
        ></v-select>
      </v-col>

      <!-- input de número de puntadas -->
      <v-col v-if="infoTecnicaSeleccionada.puntadas">
        <span class="litle-head-title">
          {{ $t("configuration.Bordado.Introduce el número de puntadas") }}
        </span>
        <v-text-field
          v-model="params.puntadas"
          :suffix="$t('configuration.Bordado.puntadas')"
          label=""
          hide-details="true"
          type="number"
          prepend-inner-icon="mdi-basket-fill"
          color="primary darken-2"
        ></v-text-field>
      </v-col>

      <!-- selector de tamano de impresion -->
      <v-col v-if="infoTecnicaSeleccionada.idTamImpresion">
        <!-- <div class="litle-head-alert">
          {{ $t("configuration.El tamaño máximo para esta combinación de tallas es") }}: <br>{{  actualMaxValidSizeImpresionDirecta.text }}  
          <template v-if="false">({{actualMaxValidSize.cm2MaxSize}}mm)</template>
        </div> -->
        <span class="litle-head-title">
          {{ $t("configuration.ImpresionDirecta.Tamaño del estampado") }}
        </span>
        <v-select
          v-model="params.idTamImpresion"
          :items="tamanosImpresionDirecta"
          label=""
          color="primary darken-2"
          prepend-inner-icon="mdi-tape-measure"
        ></v-select>
      </v-col>

      <!-- Selector de tamano estampados para números dtf -->
      <v-col v-if="infoTecnicaSeleccionada.tamanoEstampadoNumerosDTF" cols="12">
        <span class="litle-head-title">
          {{ $t("general.Tamaño") }}
        </span>
        <v-select
          v-model="params.tamanoEstampadoNumerosDTF"
          :items="filteredOptions"
          label=""
          item-text="label"
          item-value="value"
          color="primary darken-2"
          prepend-inner-icon="mdi-tape-measure"
        ></v-select>
      </v-col>

      <!-- check para indicar si impremimos a doble número o no -->
      <v-col v-if="infoTecnicaSeleccionada.dobleNumero">
        <v-checkbox
          v-model="params.dobleNumero"
          :label="$t('configuration.Numeros.NumDobles')"
          color="primary darken-2 white--text"
          class="mt-1 pt-1"
          hide-details="true"
        ></v-checkbox>
      </v-col>

      <!-- Input para el número de metros lineales -->
      <v-col
        v-if="infoTecnicaSeleccionada.MetrosLineales && seEnvianMetrosLineales"
      >
        <span class="litle-head-title">
          {{ $t("configuration.DTF.Metros lineales") }}
        </span>
        <v-text-field
          v-model="params.MetrosLineales"
          label=""
          hide-details="true"
          type="number"
          color="primary darken-2"
          min="1"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Selector de caras -->
    <v-row v-if="infoTecnicaSeleccionada.caras">
      <v-col>
        <span class="litle-head-title">
          {{ $t("configuration.Sublimacion.Nº de caras") }}
        </span>
        <v-select
          v-model="params.numCaras"
          hide-details="true"
          prepend-inner-icon="mdi-asterisk"
          color="primary darken-2"
          :items="numCarasAvaliblesArray"
        ></v-select>
      </v-col>
    </v-row>

    <!-- Selector de gajos -->
    <v-row v-if="infoTecnicaSeleccionada.gajos">
      <v-col>
        <span class="litle-head-title">
          {{ $t("configuration.CalculoPrecios.Gajos") }}
        </span>
        <v-select
          v-model="params.gajos"
          :items="numGajosDisponibles"
          label=""
          color="primary darken-2"
          prepend-inner-icon="mdi-format-color-fill"
          hide-details
          class="mt-0 py-0"
        ></v-select>
      </v-col>
    </v-row>

    <!-- Selector de tipo de termograbado -->
    <v-row v-if="infoTecnicaSeleccionada.typeTermograbado">
      <v-col>
        <span class="litle-head-title">
          {{ $t("configuration.CalculoPrecios.tipoTermograbado") }}
        </span>
        <v-select
          v-model="params.typeTermograbado"
          :items="avalibleTermograbado"
          label=""
          color="primary darken-2"
          prepend-inner-icon="mdi-cog"
          hide-details="true"
          class="mt-0 py-0"
        ></v-select>
      </v-col>
    </v-row>

    <!-- Selector cm2 para digital -->
    <v-row v-if="infoTecnicaSeleccionada.tamanocm2Digital">
      <v-col>
        <!-- <div class="litle-head-alert">
          {{ $t("configuration.simpleMaxSizeMessage") }}: <br>{{maxValidSizeDigital}}cm2 
        </div> -->

        <span class="litle-head-title">
          {{ $t("configuration.CalculoPrecios.tamaño") }}
        </span>
        <v-select
          v-model="digitalTam"
          :items="actualPositionSizeDigitalOptions"
          item-text="label"
          item-value="code"
          label=""
          color="primary darken-2"
          prepend-inner-icon="mdi-crop-free"
          hide-details="true"
          class="mt-0 py-0"
        ></v-select>
      </v-col>
    </v-row>

    <!-- Selector cm2 para Doming -->
    <v-row v-if="infoTecnicaSeleccionada.tamanoCm2Doming">
      <v-col>
        <!-- <div class="litle-head-alert">
          {{ $t("configuration.simpleMaxSizeMessage") }}: <br>{{  maxValidSizeDoming.cm2 }}cm2 ({{maxValidSizeDoming.cm2MaxSize}}mm)
        </div> -->
        <span class="litle-head-title">
          {{ $t("configuration.CalculoPrecios.tamaño") }}
        </span>
        <v-select
          v-model="params.domingTamCode"
          :items="avalibleSizeDoming"
          item-text="label"
          item-value="code"
          label=""
          color="primary darken-2"
          prepend-inner-icon="mdi-crop-free"
          hide-details="true"
          class="mt-0 py-0"
        ></v-select>
      </v-col>
    </v-row>

    <!-- Input para aquellas técnicas que no tienen valores fijos en cm2 -->
    <v-row v-if="infoTecnicaSeleccionada.tamanoCm2 && !seEnvianMetrosLineales">
      <v-col>
        <!-- <div class="litle-head-alert">
          {{ $t("configuration.simpleMaxSizeMessage") }}: <br>{{  maxSizeForTamanoCm2.Area }}cm2 ({{maxSizeForTamanoCm2.Alto}}x{{maxSizeForTamanoCm2.Ancho}}mm)
        </div> -->
        <span class="litle-head-title">
          {{ $t("configuration.CalculoPrecios.tamaño") }}
        </span>
        <v-text-field
          v-model="params.tamanoCm2Area"
          :disabled="isSizeTamanoCm2Forced"
          type="number"
          label=""
          min="1"
          :max="maxSizeForTamanoCm2?.Area ?? 1"
          color="primary darken-2"
          prepend-inner-icon="mdi-tshirt-crew"
          hide-details
          class="mt-0 py-0"
          @input="updateSizeCm2Debounced($event, 'Area')"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-checkbox
          v-model="params.hasPlanchado"
          :label="$t('configuration.DTF3D.PreguntaPlanchado')"
          color="primary darken-2 white--text"
          class="mt-1 pt-1"
          hide-details="true"
        ></v-checkbox>
      </v-col>

      <v-col v-if="infoTecnicaSeleccionada.efecto3d" cols="12" md="6">
        <span class="litle-head-title">
          {{ $t("configuration.DTF3D.Efecto") }}
        </span>
        <v-select
          v-model="params.efecto3d"
          :items="dtf3dEfectoOptions"
          item-text="text"
          item-value="value"
          dense
          outlined
          hide-details="true"
          class="mt-1"
        ></v-select>
      </v-col>
    </v-row>

    <!-- Alerta enc aso de que exista para la técnia/modelo actual -->
    <v-row v-if="alertInfo?.length" class="pt-6">
      <v-col cols="12">
        <v-card v-for="alert in alertInfo" :key="alert.text">
          <v-alert
            :type="alert.type ?? warning"
            :color="alert.color ?? ''"
            elevation="8"
            text
            dense
            class="mb-3"
          >
            {{ alert.text }}
          </v-alert>
        </v-card>
      </v-col>
    </v-row>

    <!-- Activar ajustes avanzados -->
    <v-row class="pt-3" :class="{ 'pb-4': !showOpcionesAvanzadas }">
      <v-col class="d-flex justify-start align-center">
        <a
          href="javascript:;"
          @click="showOpcionesAvanzadas = !showOpcionesAvanzadas"
        >
          <v-icon>
            <template v-if="!showOpcionesAvanzadas">mdi-chevron-right</template>
            <template v-else>mdi-chevron-down</template>
          </v-icon>

          {{ $t("general.advancedOptions") }}
        </a>
      </v-col>
      <v-col
        v-if="!showOpcionesAvanzadas"
        class="d-flex justify-end align-center"
      >
        <a href="javascript:;" @click="removeZone">
          {{ $t("general.Eliminar zona") }}
          <v-icon>mdi-close</v-icon>
        </a>
      </v-col>
    </v-row>
    <v-expand-transition>
      <v-row class="mt-5">
        <v-container v-show="showOpcionesAvanzadas" class="py-0 px-2">
          <v-row
            v-if="
              (infoTecnicaSeleccionada.maxWidth ||
                infoTecnicaSeleccionada.maxHeight) &&
              !infoTecnicaSeleccionada.noShowHeightAndWidth &&
              !seEnvianMetrosLineales
            "
          >
            <v-col
              v-if="
                infoTecnicaSeleccionada.maxWidth &&
                !infoTecnicaSeleccionada.noShowHeightAndWidth
              "
              cols="12"
              md="6"
            >
              <div class="custom-input">
                <div class="prepend-text">
                  {{ $t("configuration.Serigrafia.Ancho") }}
                </div>
                <v-text-field
                  v-model="params.maxWidth"
                  dense
                  hide-spin-buttons
                  type="number"
                  class="input-number"
                  suffix="mm"
                  outlined
                  :error="params.maxWidth > dinADimension?.Ancho"
                  @change="updateTamanoByHeightAndWidth"
                />
              </div>
            </v-col>
            <v-col
              v-if="
                infoTecnicaSeleccionada.maxHeight &&
                !infoTecnicaSeleccionada.noShowHeightAndWidth
              "
              cols="12"
              md="6"
            >
              <div class="custom-input">
                <div class="prepend-text">
                  {{ $t("configuration.Serigrafia.Alto") }}
                </div>
                <v-text-field
                  v-model="params.maxHeight"
                  dense
                  hide-spin-buttons
                  type="number"
                  class="input-number"
                  suffix="mm"
                  :error="params.maxHeight > dinADimension?.Alto"
                  outlined
                  @change="updateTamanoByHeightAndWidth"
                />
              </div>
            </v-col>
          </v-row>

          <!-- input exclusivos de las técnicas con tamanoCm2 para poder modificar width and height -->
          <v-row v-if="infoTecnicaSeleccionada.tamanoCm2 && !seEnvianMetrosLineales">
            <v-col>
              <div class="custom-input">
                <div class="prepend-text">
                  {{ $t("configuration.Serigrafia.Ancho") }}
                </div>
                <v-text-field
                  v-model="widthTamanoCm2"
                  :disabled="isSizeTamanoCm2Forced"
                  dense
                  hide-spin-buttons
                  type="number"
                  class="input-number"
                  suffix="mm"
                  min="1"
                  :hint="
                    $t('general.maxMmSizeLabel', {
                      maxValue: maxSizeForTamanoCm2?.Ancho ?? 1
                    })
                  "
                  :max="maxSizeForTamanoCm2?.Ancho ?? 1"
                  outlined
                  @change="updateSizeCm2($event, 'Ancho')"
                />
              </div>
            </v-col>
            <v-col>
              <div class="custom-input">
                <div class="prepend-text">
                  {{ $t("configuration.Serigrafia.Alto") }}
                </div>
                <v-text-field
                  v-model="heightTamanoCm2"
                  :disabled="isSizeTamanoCm2Forced"
                  dense
                  hide-spin-buttons
                  type="number"
                  class="input-number"
                  suffix="mm"
                  min="1"
                  :hint="
                    $t('general.maxMmSizeLabel', {
                      maxValue: maxSizeForTamanoCm2?.Alto ?? 1
                    })
                  "
                  :max="maxSizeForTamanoCm2?.Alto ?? 1"
                  outlined
                  @change="updateSizeCm2($event, 'Alto')"
                />
              </div>
            </v-col>
          </v-row>

          <v-row>
            <!-- Check para planchado (texto original para técnicas existentes) -->
            <v-col
              v-if="infoTecnicaSeleccionada.hasPlanchado && !infoTecnicaSeleccionada.efecto3d"
              cols="6"
            >
              <v-checkbox
                v-model="params.hasPlanchado"
                :label="$t('configuration.Serigrafia.PreguntaPlanchado')"
                color="primary darken-2 white--text"
                class="mt-1 pt-1"
                hide-details="true"
              ></v-checkbox>
            </v-col>

            <!-- Check para especificar tinta negra -->
            <v-col v-if="infoTecnicaSeleccionada.tintaNegra" cols="6">
              <span v-if="params.colores == 1" class="d-flex">
                <v-checkbox
                  v-model="params.tintaNegra"
                  :label="$t('configuration.Serigrafia.Usar tinta negra')"
                  color="primary darken-2 white--text"
                  class="mt-1 pt-1"
                  hide-details="true"
                ></v-checkbox>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon class="mt-1">mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span class="litle-head-title">
                    {{
                      $t(
                        "configuration.Serigrafia.Si alguno de los colores contiene el color negro"
                      )
                    }}
                  </span>
                </v-tooltip>
              </span>
            </v-col>

            <!-- Check para cambiar indicar que vamos a indicar metros lineales -->
            <v-col v-if="infoTecnicaSeleccionada.MetrosLineales && !forceEnviarMetrosLineales">
              <span v-if="params.colores == 1" class="d-flex">
                <v-checkbox
                  v-model="seEnvianMetrosLineales"
                  :label="$t('configuration.DTF.Metros lineales')"
                  color="primary darken-2 white--text"
                  class="mt-1 pt-1"
                  hide-details="true"
                ></v-checkbox>
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon class="mt-1">mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span class="litle-head-title">
                    {{ $t($t("configuration.DTF.Aviso metros")) }}
                  </span>
                </v-tooltip>
              </span>
            </v-col>

            <!-- Check para indicar que se va aplicar un diseño especial para números -->
            <v-col v-if="infoTecnicaSeleccionada.disenoEspecial">
              <v-checkbox
                v-model="params.disenoEspecial"
                color="primary darken-2 white--text"
                hide-details="true"
                :label="$t(`configuration.NumerosDtf.DisenoEspecial`)"
              ></v-checkbox>
            </v-col>

            <!-- Check para indicar si debemos mostrar el check para doble base en serigrafía -->
            <v-col v-if="hasDobleBaseSerigrafia">
              <v-checkbox
                v-model="params.dobleBaseSerigrafia"
                color="primary darken-2 white--text"
                class="warning-text"
                :error="!params.dobleBaseSerigrafia"
                hide-details="true"
                :label="$t('configuration.Serigrafia.CheckBasePrendasOscuras')"
              ></v-checkbox>
            </v-col>

            <!-- Check para indicar si debemos usar cortahilos en bordado o no -->
            <v-col v-if="infoTecnicaSeleccionada.cortahilos">
              <v-checkbox
                v-model="params.cortahilos"
                color="primary darken-2 white--text"
                class="warning-text mt-0"
                hide-details="true"
                :label="$t('configuration.Bordado.cortahilos')"
              ></v-checkbox>
            </v-col>

            <!-- Checkbox para indicar que se va a realizar una personalización nombre a nombre -->
            <v-col v-if="isAvalibleNombreaNombre">
              <v-checkbox
                v-model="params.nombreANombre"
                color="primary darken-2 white--text"
                hide-details="true"
                :label="$t('general.NombreANombre')"
              ></v-checkbox>
            </v-col>
          </v-row>

          <!-- Selector de tipo de tinta -->
          <v-row v-if="infoTecnicaSeleccionada.idTipoTinta">
            <v-col>
              <span class="litle-head-title">
                {{ $t("configuration.Tintas.Tipo de tinta") }}
              </span>
              <v-select
                v-model="params.idTipoTinta"
                :items="allTintas"
                label=""
                outlined
                color="primary darken-2"
                prepend-inner-icon="mdi-water-outline"
                class="mt-1"
                hide-details="true"
              ></v-select>
              <span class="litle-head-title">
                {{
                  $t(
                    "configuration.Tintas.Si la prenda es elástica (elastano) o el tejido es de canalé, se ha de aplicar tinta para elastano"
                  )
                }}
              </span>
            </v-col>
          </v-row>

          <!-- Check obligatorio para mostrar la posibilidad de indicar que es una repetición -->
          <v-row >
            <v-col class="container-check-repeticion" cols="12" md="6">
              <check-repeticion
                v-if="activeComercial && infoTecnicaSeleccionada.repeticion"
                v-model="params.esRepeticion"
                :id-zone="zona.id"
              ></check-repeticion>
            </v-col>

            <v-col>
              <div class="d-flex justify-end align-center h-100 mb-4">
                <a href="javascript:;" @click="removeZone">
                  {{ $t("general.Eliminar zona") }}
                  <v-icon>mdi-close</v-icon>
                </a>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-expand-transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import configTecnicasUtil from "@/utils/tecnicasUtils.js";

import CheckRepeticion from "@/components/basic/CheckRepeticion.vue";

import { scaleLogo, calcularIncrementoEscala, estimateRealMmDimensions } from "@/utils/customDimUtils" 

export default {
  components: {
    CheckRepeticion
  },
  props: {
    // Zona actual a la que vamos a calcularle el precio
    zona: {
      type: Object,
      required: true,
      validator: function (value) {
        return value?.Posicion && value?.Zona && value?.Tecnicas;
      }
    },
    // Valor para indicar si es el calculador actualmente visible o no
    selected: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      tecnicaSeleccionada: null, // Técnica seleccionada
      specificTecnicaSeleccionadOfGroup: null, // Técnica seleccionada de un grupo de técnicas (en caso de que tecnicaSeleccionada sea un grupo)
      cargandoTabZona: false, // Loading para la zona
      showOpcionesAvanzadas: false, // Check para mostrar o no las opciones avanzadas
      lastAtrb: null, // Última configuración de parámetros para los que se ha calculado el precio
      seEnvianMetrosLineales: false, // Check para comprobar si se deben mandar metros lineales o no en el DTF original
      forceEnviarMetrosLineales: false, // Para la nueva tarifa O6 que representa los metros lineales en el sistema de tarifas
      widthTamanoCm2: 0, // Variable auxiliar para indicar el ancho en caso de que se especifique un tamaño en cm2
      heightTamanoCm2: 0, // Variable auxiliar para indicar el alto en caso de que se especifique un tamaño en cm2
      debouncedCalculate: null, // Función debounce en el calculo del precio
      digitalTam: null, // Tamaño seleccionado para digital en cm2

      // Parametros del calcula que se enviarán en la petición
      params: {
        tamano: null,
        maxWidth: 0,
        maxHeight: 0,
        hasPlanchado: null,
        repeticion: null,
        tintaNegra: false,
        colores: 1,
        idTipoTinta: 5,
        esRepeticion: false,
        puntadas: 1,
        idTamImpresion: 4,
        MetrosLineales: 1,
        dobleNumero: false,
        tamanoEstampadoNumerosDTF: null,
        disenoEspecial: false,
        typeColor: null,
        maxHeightSelect: 100,
        numCaras: 1,
        gajos: 1,
        efecto3d: false,

        domingTamCode: null,
        nombreANombre: false,
        tamanoCm2Area: 0,
        typeTermograbado: null,
        cortahilos: false,

        // atributos sin inputs
        prendasBlanco: 0,
        prendasClaro: 0,
        prendasOscuro: 0
      },

      debounceScale3D: null, // Función debunce a la hora de actualizar los tamaños
      debounceArea: null, // Debounce para el campo Area de cm2 (evita corrupción de ratio en escritura parcial)
      logoRatio3D: null,   // Ratio fijo capturado al cargar el logo (evita deriva por escalados sucesivos)
      logoRatio3DId: null, // Id del logo cuyo ratio está almacenado (se resetea al cambiar de logo)
      gajosByTecnica: {}, // Selección de gajos independiente por técnica
    };
  },
  computed: {
    ...mapGetters("design", [
      'getDesignByIdAndZone',
      "imgInfoCanvas3d",
      "activeZone3D",
      "activeZoneMaxSize"
    ]),
    ...mapGetters("carrito", [
      "soloBlancoEnCarritoSublimacion",
      "loadingCarrito",
      "carrito",
      "medidasMaximas",
      "numReprocesosSerigrafiaOrTransfer",
      "hasPackUno",
      "idOfActualHasDesembolsadoPack",
      "totalUnidades",
      "quantityByColor",
      "unidadMasPequeña"
    ]),
    ...mapGetters("modelo", [
      "isReprocesosStm",
      "tieneSublimacionTotal",
      "sublimacionStmInfo",
      "getFilteredTecnicasExtra",
      "transferStmTypeAvalible",
      "maxValidSize",
      "zonesFondoByZone",
      "modelInfoFromCatalog",
      "stmMaxColor",
      "modelPrice",
      "listColorFondo",
      "zonasDescription",
      "isStaminaModel",
      "advertenciaSerigrafia",
      "tecnicaRecomendada",
      "forzarTipoTinta"
    ]),
    ...mapGetters("config", [
      "allSizeByTecnica",
      "getMedidasByTamano",
      "allTintas",
      "tamanosImpresionDirecta",
      "optionsNumbers",
      "sizeDigitalOptions",
      "sublimacionTecnicas",
      "activeComercial"
    ]),
    // Obtiene la información del diseño actual, junto al tamaño en el canvas 3d si procede
    actualDesignZone() {
      let design = this.getDesignByIdAndZone({
        id: this.zona.id,
        posicion: this.zona.Posicion
      })

      if (design?.idImg && design?.mode == '3d') {
        design.img3DInfo = this.imgInfoCanvas3d[design.idImg]
      }

      return design
    },

    // Variable que indica el número de colores del logo subido
    logoNumColor() {
      if (!this.actualDesignZone || !this.actualDesignZone.numColor) {
        return 0;
      }

      return this.actualDesignZone.numColor;
    },

    // Información de tamaños del logo en el diseñador 3d
    dimensionLogo3d() {
      if (!this.actualDesignZone || !this.actualDesignZone.img3DInfo) {
        return;
      }

      if (!this.actualDesignZone.img3DInfo.widthMm || !this.actualDesignZone.img3DInfo.heightMm) {
        console.warn("A la hora de recuperar el tamaño de un logo 3d, no soy capaz de encontrar la equivalencia en mm ", this.actualDesignZone)
        return;
      }

      return {
        width: this.actualDesignZone.img3DInfo.widthMm,
        height: this.actualDesignZone.img3DInfo.heightMm
      }
    },
    // Obtiene la imagen de la zona actual
    imgDesignZone() {
      return this.actualDesignZone?.design
    },
    // Función para contar el número de elementos blancos que hay en el carrito
    numProductosBlancos() {
      let numBlancos = 0;

      numBlancos = this.carrito.productos.reduce(
        (total, p) =>
          p.color == "01" ||
          (this.zonesFondoByZone(this.zona.Posicion)?.AvalibleColors.find(
            c => c.Color == p.color
          )?.isBlanco ??
            false)
            ? total + Number.parseInt(p.cantidad)
            : total,
        0
      );

      return numBlancos;
    },
    isZoneOnlyBlanco() {
      return this.totalUnidades == this.numProductosBlancos;
    },
    // Array de técnicas disponibles con la configuración de parámetros que debemos hacer
    tecnicas() {
      let sublimacionInfo = null;
      let serigrafiaInfo = null;
      let transferInfo = null;
      let transferSerigraficoInfo = null;
      let transferDigitalInfo = null;
      let digitalInfo = null;

      if (this.isReprocesosStm) {
        sublimacionInfo = this.sublimacionStmInfo(this.zona.Posicion);
        serigrafiaInfo = this.getFilteredTecnicasExtra(
          this.zona.Posicion,
          "Serigrafia"
        );
        transferInfo = this.getFilteredTecnicasExtra(
          this.zona.Posicion,
          "Transfer"
        );

        transferSerigraficoInfo = this.getFilteredTecnicasExtra(
          this.zona.Posicion,
          "TransferSerigraficoStm"
        );

        transferDigitalInfo = this.getFilteredTecnicasExtra(
          this.zona.Posicion,
          "TransferDigitalStm"
        );

        digitalInfo = this.getFilteredTecnicasExtra(
          this.zona.Posicion,
          "Digital"
        );
      }

      // Recuperamos la información para el listado actual
      let listTecnicas = configTecnicasUtil.tecnicasListCreator(
        this.zona.Tecnicas,
        this.isReprocesosStm,
        {
          soloBlancoEnCarritoSublimacion: this.soloBlancoEnCarritoSublimacion,
          tieneSublimacionTotal: this.tieneSublimacionTotal,
          isSublimacionSombreros: sublimacionInfo?.Type == "Sombreros",
          isSublimacionTazas: sublimacionInfo?.Type == "Tazas",
          isLanyardSublimacion: sublimacionInfo?.NumCaras,
          useGajosSerigrafia: serigrafiaInfo?.Type == "Gajos",
          useGajosTransfer: transferInfo?.Type == "Gajos",
          useGajosTransferSerigrafico:
            (transferSerigraficoInfo?.Type ?? transferInfo?.Type) == "Gajos",
          useGajosTransferDigital:
            transferDigitalInfo?.Type == "Gajos",
          isSerigrafiaSombreros: serigrafiaInfo?.Type == "Sombreros",
          tecnicasTransfer: transferInfo?.AvaliblesTransfer,
          useDigitalTextil: digitalInfo?.Type == "Textil",
          useCalzadoTransfer:
            (transferDigitalInfo?.Type ?? transferInfo?.Type) == "Calzado",
          useTransferTextil:
            (transferSerigraficoInfo?.TypeProducto ?? transferInfo?.TypeProducto) ==
            "Textil",
          useSerigrafiaTextil: serigrafiaInfo?.Type == "Textil",
          useTintasInSerigrafiaStm: serigrafiaInfo?.UseTintas ?? false
        }
      );

      return listTecnicas.map(t => {
        let label = this.$t("tecnicas." + t.nombreTecnica);
        
        if (t.nombreTecnica == "SERIGRAFÍA" && this.advertenciaSerigrafia) {
          label += ` (${this.$t("general.ConsultarAcabado")})`;
        }


        let tecnicaRecomendada = this.tecnicaRecomendada

        const hasTransferRecomend =
          this.advertenciaSerigrafia &&
          (t.nombreTecnica == "TRANSFER" ||
            t.groupTecnica == "TRANSFER" ||
            t.valueTecnica == "DTF");

        if(hasTransferRecomend) {
          tecnicaRecomendada = "TRANSFER";
        }

        if (
          tecnicaRecomendada &&
          t.nombreTecnica.includes(tecnicaRecomendada.toUpperCase())
        ) {
          if (
            !t.groupTecnica ||
            !t.groupTecnica.includes(tecnicaRecomendada.toUpperCase())
          ) {
            label += ` (${this.$t("general.Recomendado")})`;
          }

          t.isTecnicaRecomendada = true;
        }

        return {
          ...t,
          label
        };
      });
    },

    // Tecnicas agrupadas por grupos, en caso de que no exista grupo, no se mostrará
    groupedTecnicas() {
      let grouped = {};

      this.tecnicas.forEach(t => {
        if (!t.groupTecnica) return;

        if (!grouped[t.groupTecnica]) grouped[t.groupTecnica] = [t];
        else grouped[t.groupTecnica].push(t);
      });

      return grouped;
    },

    selectedGroupedTecnica() {
      if (!this.groupedTecnicas[this.tecnicaSeleccionada]) {
        return null;
      }
      return [...this.groupedTecnicas[this.tecnicaSeleccionada]].sort((a,b) => a.orderTecnica - b.orderTecnica);
    },

    // Bool que indica si tenemos algun grupo seleccionado
    hasGroupedTecnicaSelected() {
      return !!this.selectedGroupedTecnica;
    },

    // Bool para mostrar o no el selector de técnicas por grupo
    showSelectSpecificTecnicaOfGroup() {
      return (
        this.hasGroupedTecnicaSelected &&
        (this.selectedGroupedTecnica?.length ?? 0) > 1
      );
    },

    // Listado de técnicas a mostrar
    groupedTecnicasArray() {
      let array = [];

      this.tecnicas.forEach(t => {
        if (!t.groupTecnica) array.push(t);
      });

      Object.keys(this.groupedTecnicas).forEach(t => {
        let actualTecnica = this.groupedTecnicas[t][0];
        let label = this.$t("tecnicas." + actualTecnica?.groupTecnica);

        if (this.groupedTecnicas[t].length == 1) {
          label = this.$t("tecnicas." + this.groupedTecnicas[t][0]?.nombreTecnica);
        }

        if (actualTecnica?.isTecnicaRecomendada) {
          label += ` (${this.$t("general.Recomendado")})`;
        }

        array.push({
          nombreTecnica: t,
          valueTecnica: t,
          label,
          orderTecnica: actualTecnica?.orderTecnica || 0
        });
      });

      return array
    },

    // Información completa de los parametros a usar para la técnica seleccionada
    infoTecnicaSeleccionada() {
      if (!this.tecnicaSeleccionada || !this.tecnicas?.length) return {};

      if (this.hasGroupedTecnicaSelected) {
        return (
          this.tecnicas.find(
            t => this.specificTecnicaSeleccionadOfGroup == t.valueTecnica
          ) ?? {}
        );
      }

      return (
        this.tecnicas.find(t => this.tecnicaSeleccionada == t.valueTecnica) ??
        {}
      );
    },

    // Opciones DTF números filtradas por numeros dobles
    filteredOptions() {
      return this.optionsNumbers(
        this.infoTecnicaSeleccionada,
        this.params.dobleNumero
      );
    },

    // Indicador de doble base en serigrafia
    hasDobleBaseSerigrafia() {
      return (
        this.infoTecnicaSeleccionada.dobleBaseSerigrafia &&
        this.getFilteredTecnicasExtra(this.zona.Posicion, "Serigrafia")
          ?.AplicarBase
      );
    },

    // Número de gajos disponibles para la técnica seleccionada
    numGajosDisponibles() {
      let gajos = [];

      const valueTecnica = this.infoTecnicaSeleccionada.valueTecnica ?? "";

      let tecnica = valueTecnica.replace("Stm", "");
      if (valueTecnica.startsWith("Serigrafia")) {
        tecnica = "Serigrafia";
      } else if (valueTecnica.startsWith("TransferDigital")) {
        tecnica = "TransferDigitalStm";
      } else if (valueTecnica.startsWith("TransferSerigrafico")) {
        tecnica = "TransferSerigraficoStm";
      } else if (valueTecnica.startsWith("Transfer")) {
        tecnica = "Transfer";
      }

      let tecnicaExtra = this.getFilteredTecnicasExtra(this.zona.Posicion, tecnica);

      if (!tecnicaExtra && tecnica == "TransferSerigraficoStm") {
        tecnicaExtra = this.getFilteredTecnicasExtra(this.zona.Posicion, "Transfer");
      }

      let maxNumGajos = Number.parseInt(
        tecnicaExtra?.NumGajos ?? 0
      );

      for (let i = 1; i <= maxNumGajos; i++) {
        gajos.push(i);
      }
      return gajos;
    },

    // Tamaño máximo para impresión directa
    actualMaxValidSizeImpresionDirecta() {
      if (this.carrito.productos.length == 0 || !this.tamanosImpresionDirecta)
        return null;
      return this.maxValidSize({
        avalibleSizes: this.tamanosImpresionDirecta,
        zona: this.zona.Posicion
      });
    },

    // Tamano máximo para la técnica numeros dtf
    actualMaxValidSizeNumDtf() {
      if (!this.filteredOptions.length) return;

      let maxValue = null;
      this.filteredOptions.forEach(tam => {
        let isPrimerValor = !maxValue;

        let firstValueOrIsBigger =
          isPrimerValor ||
          (tam.Ancho >= maxValue.Ancho && tam.Alto >= maxValue.Alto);

        let numExcededSize = this.medidasMaximas({
          posicion: this.zona.Posicion,
          xaxis: tam.Ancho,
          yaxis: tam.Alto
        });

        if (firstValueOrIsBigger && numExcededSize.length == 0) maxValue = tam;
      });

      return maxValue;
    },

    // Altura máxima si lo ponemos en formato de select (para transferNumeros)
    maxHeightSelectOption() {
      if (!this.filteredOptions.length) return;

      return this.filteredOptions
        .filter(option => option.Type === this.params.typeColor)
        .map(option => option.Alto);
    },

    // Número máximo de colores en caso de tratarse de transferNumeros
    maxColorSelectNumerosOption() {
      if (!this.filteredOptions.length) return;

      const maxColor =
        this.filteredOptions.find(
          option => option.Type === this.params.typeColor
        )?.MaxColor ?? 0;

      return maxColor <= 1
        ? [1]
        : Array.from({ length: maxColor }, (_, i) => i + 1);
    },

    // Listado de valores posibiles para el selector de caras
    numCarasAvaliblesArray() {
      if (this.modelInfoFromCatalog.code == "CP9001")
        return [{ value: 1, text: 1 }];
      if (
        this.infoTecnicaSeleccionada.valueTecnica?.startsWith("SublimacionStm")
      ) {
        // Recuperamos el número de caras
        let numCarasSublimacion = this.getFilteredTecnicasExtra(
          this.zona.Posicion,
          "Sublimacion"
        )?.NumCaras;

        if (numCarasSublimacion == 0) {
          return [
            {
              text: "1",
              value: 1
            },
            {
              text: "2",
              value: 2
            }
          ];
        }

        if (this.infoTecnicaSeleccionada.specificCaras) {
          // Solo el número de caras especificado
          return [
            {
              text: `${numCarasSublimacion}`,
              value: Number(numCarasSublimacion)
            }
          ];
        }

        let result = [];
        let index = 0;
        while (index < numCarasSublimacion) {
          result.push({
            text: (index + 1).toString(),
            value: index + 1
          });
          index++;
        }

        return result;
      } else return [{ value: 2, text: 2 }];
    },

    // Calculo de tamaños disponibles para la técnica actual
    tamanos() {
      return this.allSizeByTecnica(
        this.tecnicaSeleccionada,
        this.zona.Posicion
      );
    },

    // Array de tamaño
    tamanosArray() {
      return Object.keys(this.tamanos);
    },

    // Computed para calcular el tamaño máximo válido para el conjunto de productos actualmente seleccionado
    actualMaxValidSize() {
      if (
        this.infoTecnicaSeleccionada.idTamImpresion ||
        this.infoTecnicaSeleccionada.tamanocm2Digital ||
        this.infoTecnicaSeleccionada.tamanoCm2Doming ||
        this.infoTecnicaSeleccionada.tamanoCm2
      )
        return null;

      if (this.carrito.productos.length == 0 || !this.zona) return null;
      let customSizes = Object.keys(this.tamanos)
        .filter(s => this.tamanosArray.includes(s))
        .map(s => {
          return {
            ...this.tamanos[s],
            text: s
          };
        });

      let result = this.maxValidSize({
        avalibleSizes: customSizes,
        zona: this.zona.Posicion,
        tecnica: !this.infoTecnicaSeleccionada?.valueTecnica
          ? null
          : this.infoTecnicaSeleccionada.valueTecnica.startsWith("Serigrafia")
            ? "Serigrafia"
            : this.infoTecnicaSeleccionada.valueTecnica.startsWith("Transfer")
              ? "Transfer"
              : this.isSublimacion
                ? "Sublimacion"
                : this.infoTecnicaSeleccionada.valueTecnica.replace("Stm", "")
      });

      if (!result) {
        console.warn(
          `modelo/maxValidSize getter no ha devuelto un valor válido para la técnica ${this.tecnicaSeleccionada}. Buscando valor genérico`
        );
        result = this.maxValidSize({
          avalibleSizes: customSizes,
          zona: this.zona.Posicion
        });
      }

      if (!result?.Area && result.Alto && result.Ancho) {
        result.Area = (result.Alto * result.Ancho) / 100;
      }

      return result;
    },

    // Computed para calcular el número máximo de colores
    maxColores() {
      // Tinta vinilica
      if (this.params.idTipoTinta == 6) {
        return 1;
      } else {
        return 8;
      }
    },

    // Listado de número de colores disponibles
    coloresDisponibles() {
      const tecnica = this.infoTecnicaSeleccionada?.valueTecnica ?? "";

      let coloresMaximos = this.maxColores;

      if (this.params.tintaNegra) {
        coloresMaximos = 1;
      } else if (tecnica === "TransferNumeros") {
        coloresMaximos = this.maxColorSelectNumerosOption;
      } else if (this.isReprocesosStm) {
        if (tecnica.startsWith("Serigrafia")) {
          coloresMaximos = parseInt(
            this.stmMaxColor(this.zona.Posicion, "Serigrafia") ?? 1
          );
        } else if (tecnica === "Tampografia") {
          coloresMaximos = parseInt(
            this.stmMaxColor(this.zona.Posicion, "Tampografia") ?? 1
          );
        } else if (tecnica.startsWith("Sublima")) {
          coloresMaximos = parseInt(
            this.stmMaxColor(this.zona.Posicion, "Sublimacion") ?? 1
          );
        } else if (tecnica.startsWith("Transfer")) {
          coloresMaximos = parseInt(
            this.stmMaxColor(this.zona.Posicion, "Transfer") ?? 1
          );
        } else {
          coloresMaximos = parseInt(
            this.stmMaxColor(this.zona.Posicion, tecnica) ?? 1
          );
        }
      }

      return Array.from({ length: coloresMaximos }, (_, i) => i + 1);
    },

    // Información del tipo de fondo, dependiendo del modelo y zona (BLANCO, CLARO o OSCURO)
    infoZonasFondo: function () {
      return this.zonesFondoByZone(this.zona.Posicion);
    },

    // Computed para identificar cualquiera de los tipos de sublimación
    isSublimacion() {
      return this.sublimacionTecnicas.includes(this.tecnicaSeleccionada);
    },

    // Información de alerta
    alertInfo() {
      let listAlert = [];

      // Warning relacionadas con sublimación
      if (this.isSublimacion) {
        let sublimacionInfo = this.sublimacionStmInfo(this.zona.Posicion);

        if (sublimacionInfo?.SoloBlanco ?? false) {
          listAlert.push({
            type: "warning",
            text: this.$t("configuration.Sublimacion.sublimacionSoloBlanco")
          });
        } else {
          let fondoBlanco = false;
          const soloBlancoEnCarrito =
            this.carrito.productos.length >= 1 &&
            this.carrito.productos.every(p => p.color == "01");

          if (soloBlancoEnCarrito || this.isZoneOnlyBlanco) {
            // Si solo hay blanco en el carrito no es necesario mirar más
            fondoBlanco = true;
          }

          if (!fondoBlanco) {
            listAlert.push({
              type: "warning",
              text: this.$t("errores.alert.alertSublimacionZonaNoBlanca")
            });
          }
        }
      }

      return listAlert;
    },

    maxValidSizeDigital() {
      if (!this.actualPositionSizeDigitalOptions) return null;
      
      let mapSizes = this.actualPositionSizeDigitalOptions.map((t, index, array) => {
        return {
          cm2: index > 0 ? array[index - 1].value : 0,
          value: t.code,
          upperValue: t.value
        };
      });

      return this.maxValidSize({
        avalibleSizes: mapSizes,
        zona: this.zona.Posicion
      });
    },

    // Tamaños disponibles para Digital para la posición actual
    actualPositionSizeDigitalOptions() {
      let result = this.sizeDigitalOptions[this.zona.Posicion];

      if (!result) return [];
      return [...result].sort((a, b) => a.value - b.value);
    },

    maxValidSizeDoming() {
      let mapSizes = this.avalibleSizeDoming.map(t => {
        return {
          cm2: t.value,
          value: t.code
        };
      });

      return this.maxValidSize({
        avalibleSizes: mapSizes,
        zona: this.zona.Posicion,
        tecnica: "Doming"
      });
    },

    // Listado de tamaños disponibles para Doming
    avalibleSizeDoming() {
      const listSizes = this.getFilteredTecnicasExtra(
        this.zona.Posicion,
        "Doming"
      )?.Sizes;

      if (listSizes == null) return [];

      return (
        Object.keys(listSizes)?.map(item => {
          return {
            value: listSizes[item],
            label: `${listSizes[item]} cm2`,
            code: item
          };
        }) ?? []
      );
    },

    // Indica si debemos forzar el tamaño máximo
    isSizeTamanoCm2Forced() {
      if (!this.infoTecnicaSeleccionada.tamanoCm2) return false;

      let tecnicaInfo = null;
      if (this.isSublimacion) {
        tecnicaInfo = this.getFilteredTecnicasExtra(
          this.zona.Posicion,
          "Sublimacion"
        );
      } else {
        tecnicaInfo = this.getFilteredTecnicasExtra(
          this.zona.Posicion,
          this.infoTecnicaSeleccionada.valueTecnica.replace("Stm", "")
        );
      }

      return tecnicaInfo?.calculateByUnits ?? false;
    },

    // Calculo de tamaño máximo para aquellas técnicas con cm2 como input
    maxSizeForTamanoCm2() {
      // Comprobamos que tenga activado el input de tamanoCm2
      if (
        !this.infoTecnicaSeleccionada?.valueTecnica ||
        !this.infoTecnicaSeleccionada.tamanoCm2
      ) {
        return null;
      }

      let actualTecnicaName = this.infoTecnicaSeleccionada.valueTecnica;
      // En caso de ser una de las técnicas de Transfer
      if (
        this.infoTecnicaSeleccionada.valueTecnica.startsWith("Transfer") && this.infoTecnicaSeleccionada.valueTecnica != 'TransferDigitalStm'
      ) {
        actualTecnicaName = "Transfer";
      } else if (this.isSublimacion) {
        actualTecnicaName = "Sublimacion";
      } else if(this.infoTecnicaSeleccionada.valueTecnica != 'TransferDigitalStm') {
        actualTecnicaName = this.infoTecnicaSeleccionada.valueTecnica.replace(
          "Stm",
          ""
        );
      }

      let actualInfo = this.getFilteredTecnicasExtra(
        this.zona.Posicion,
        actualTecnicaName
      );

      // Comprobamos haber obtenido la información necesaria
      if (
        !actualInfo ||
        !actualInfo.TamanoCm2 ||
        !actualInfo.Height ||
        !actualInfo.Width
      ) {
        console.warn(
          "[maxSizeForTamanoCm2] No se ha encontrado la información necesaria para calcular el tamaño máximo " + this.zona.Posicion
        );
        console.warn(actualInfo)

        // Obtenemos la unidad más pequeña y la usamos
        let result = this.unidadMasPequeña({
          posicion: this.zona.Posicion,
          tecnica: actualTecnicaName
        });

        result.Area = (result.Alto * result.Ancho) / 100;

        return result;
      }

      var listTallas = this.carrito.productos.map(p => p.talla);
      var listProduct = this.modelPrice.tallasInfo.filter(t =>
        listTallas.includes(t.Talla)
      );
      var productosSelect = [];

      if (actualTecnicaName == 'TransferDigitalStm') {
        actualTecnicaName = 'Transfer'
      }

      listProduct.forEach(x => {
        let find = x.Posiciones.find(
          p =>
            this.zona &&
            p.Posicion == this.zona.Posicion &&
            p.Tecnica == actualTecnicaName
        );

        if (!find) {
          find = x.Posiciones.find(
            p => this.zona && p.Posicion == this.zona.Posicion
          );
        }

        if (find) {
          productosSelect.push(find);
        } else {
          console.warn(
            "No hemos podido encontrar el tamaño para la técnica actual"
          );
        }
      });

      // Obtener el área más pequeña del listado de productos
      let smallestArea = Infinity;
      let ancho = 0;
      let alto = 0;
      productosSelect.forEach(producto => {
        if (ancho == 0 || alto == 0) {
          ancho = producto.Ancho;
          alto = producto.Alto;
        }

        const area = producto.Ancho * producto.Alto;
        if (area < smallestArea) {
          smallestArea = area;
          ancho = producto.Ancho;
          alto = producto.Alto;
        }
      });

      // Pasamos el area a mm para hacer bien el calculo
      let tamanoCm2 = actualInfo.TamanoCm2 * 100;

      if (tamanoCm2 < smallestArea) {
        smallestArea = tamanoCm2;

        let alturaObjetivo = actualInfo.Height;

        let anchoObjetivo = actualInfo.Width;
        return {
          Area: smallestArea / 100,
          Alto: Math.round(alturaObjetivo),
          Ancho: Math.round(anchoObjetivo)
        };
      }

      return {
        Area: smallestArea / 100,
        Alto: alto,
        Ancho: ancho
      };
    },

    // Tipos de termograbado
    avalibleTermograbado() {
      if (!this.infoTecnicaSeleccionada.typeTermograbado) {
        return [];
      }

      return Object.keys(
        this.getFilteredTecnicasExtra(this.zona.Posicion, "Termograbado")
      ).map(type => {
        return {
          text: this.$t("configuration.CalculoPrecios.Termografia." + type),
          value: type
        };
      });
    },

    // Comprobamos que el nombre a nombre solo se alique en productos de stamina
    isAvalibleNombreaNombre() {
      return this.isStaminaModel && this.infoTecnicaSeleccionada.nombreANombre
    },

    // Computed para recuperar las dimensiones del dinA seleccionado
    dinADimension() {
      return this.getMedidasByTamano(this.params.tamano)
    },

    dtf3dEfectoOptions() {
      return [
        {
          text: this.$t("configuration.DTF3D.Base"),
          value: false
        },
        {
          text: this.$t("configuration.DTF3D.Relieve"),
          value: true
        }
      ];
    }
  },
  watch: {
    // Si cambia el número de colores que tiene un logo, forzaremos a que tenga esa cantidad de colores seleccionado
    logoNumColor(newVal, oldVal) {
      if(newVal && newVal > 0) {
        if(newVal == oldVal) {
          return;
        }

        if(newVal != this.params.colores) {
          this.params.colores = newVal;
        }
      }
    },

    // En caso de que se actualice los valores de dimensionLogo3d significa que se ha estirado el tamaño del logo en el canvas, por lo que vamos a sustituirlo a por los valores de los input correspondientes
    dimensionLogo3d: {
      deep: true,
      handler(newVal, oldVal) {
        // 1. Validación de seguridad
        if (!newVal?.width || !newVal?.height) {
          return;
        }

        // Capturar ratio fijo la primera vez que aparece este logo (o si cambia de logo)
        const currentLogoId = this.actualDesignZone?.idImg;
        if (currentLogoId && currentLogoId !== this.logoRatio3DId) {
          this.logoRatio3DId = currentLogoId;
          this.logoRatio3D = newVal.width / newVal.height;
        }

        // Variable auxiliar para legibilidad
        const info = this.infoTecnicaSeleccionada;
        
        // Flag para saber si debemos recalcular selectores tipo DinA
        let updateDinASelector = false;

        // ---------------------------------------------------------
        // BLOQUE 1: Modo Estándar (DinA / MaxWidth / MaxHeight)
        // ---------------------------------------------------------
        
        // Detectar cambios en Ancho
        if (newVal.width !== oldVal?.width) {
          if (info.maxWidth && !info.noShowHeightAndWidth && this.params.maxWidth !== newVal.width) {
            this.params.maxWidth = newVal.width;
            updateDinASelector = true;
          }
        }

        // Detectar cambios en Alto
        if (newVal.height !== oldVal?.height) {
          if (info.maxHeight && !info.noShowHeightAndWidth && this.params.maxHeight !== newVal.height) {
            this.params.maxHeight = newVal.height;
            updateDinASelector = true;
          }
        }

        // Si hubo cambios relevantes para el modo DinA, actualizamos su selector
        console.log("WATCH dimensionLogo3d -> ", updateDinASelector)
        if (updateDinASelector) {
          this.updateTamanoByHeightAndWidth();
        }

        // ---------------------------------------------------------
        // BLOQUE 2: Modo Área pero para Impresion digital directa (cm²)
        // ---------------------------------------------------------

        if(this.infoTecnicaSeleccionada.tamanocm2Digital)
        {
          let bestOption = this.checkBestOptionImpresionDigital(newVal.width, newVal.height);

          console.log("🚀 ~ bestOption:", bestOption)

          // Comparamos que la mejor opcion, no sea la ya seleccionada
          if(bestOption && this.digitalTam !== bestOption.code) {
            this.digitalTam = bestOption.code;
          }

          return;
        }


        // ---------------------------------------------------------
        // BLOQUE 3: Modo Área (cm²)
        // ---------------------------------------------------------
        // Aquí agrupamos la lógica: si cambia ancho O alto, recalculamos todo el bloque cm2
        
        if (info.tamanoCm2) {
          const hasSizeChanged =
            newVal.width !== this.widthTamanoCm2 ||
            newVal.height !== this.heightTamanoCm2;

          if (hasSizeChanged) {
            const max = this.maxSizeForTamanoCm2;
            const maxArea = this.getEffectiveAreaMax(max);
            const incomingArea = (newVal.width * newVal.height) / 100;
            const tryingToSetMax = !!maxArea && this.params.tamanoCm2Area >= (maxArea - 0.01);

            // Solo al intentar el maximo: si el rebote 3D se va por encima, forzamos primer valido por debajo.
            if (max && tryingToSetMax && incomingArea > maxArea) {
              const resolved = this.resolveRoundedCm2Dimensions(newVal.width, newVal.height, max, {
                preferBelowAreaMax: true,
                areaMax: maxArea
              });

              this.widthTamanoCm2 = resolved.width;
              this.heightTamanoCm2 = resolved.height;
              this.params.tamanoCm2Area = Number.parseFloat(resolved.area.toFixed(2));
            } else {
              // Comportamiento actual para el resto de casos (sin tocar la logica existente)
              this.widthTamanoCm2 = Math.round(newVal.width);
              this.heightTamanoCm2 = Math.round(newVal.height);
              const newArea = (this.widthTamanoCm2 * this.heightTamanoCm2) / 100;
              this.params.tamanoCm2Area = Number.parseFloat(newArea.toFixed(2));
            }
          }
        }
      }
    },

    async digitalTam(newVal, oldVal) {
      console.log("WATCH digitalTam:", newVal, oldVal)
      if (newVal && oldVal && newVal == oldVal) return;

      let selectedOption = this.actualPositionSizeDigitalOptions.find(o => o.code == newVal);
      console.log("🚀 ~ selectedOption:", selectedOption, this.actualPositionSizeDigitalOptions)

      if (!selectedOption) return;

      this.calculateActualTecnicaDebounced();
      
      let bestOption = this.checkBestOptionImpresionDigital(this.dimensionLogo3d?.width, this.dimensionLogo3d?.height);

      console.log("TEST bestOption => ", bestOption)

      if (bestOption && bestOption.code == newVal) {
        return;
      }

      // Siempre ajustamos al más pequeño de los dos, si tenemos dimensiones definidas (Roly)
      if (selectedOption.width && selectedOption.height) {
        if (this.dimensionLogo3d?.width >= this.dimensionLogo3d?.height) {
          await this.updateScale3DLogo(selectedOption.width, 'width');
        }
        else
        {
          await this.updateScale3DLogo(selectedOption.height, 'height');
        }
      }
    },

    async widthTamanoCm2(newVal, oldVal) {
      console.log("WATCH widthTamanoCm2", newVal, oldVal)
      if (newVal && oldVal && newVal == oldVal) return;

      await this.updateScale3DLogo(newVal, 'width');
    },

    async heightTamanoCm2(newVal, oldVal) {
      console.log("WATCH heightTamanoCm2", newVal, oldVal)
      if (newVal && oldVal && newVal == oldVal) return;

      await this.updateScale3DLogo(newVal, 'height');
    },


    // Si se actualiza el listado de técnicas, intentamos buscar la técnica seleccionada, si ya no existe, ponemos la primera valida
    tecnicas(newVal) {
      if (newVal?.length) {
        if (
          newVal.some(
            t =>
              (!this.hasGroupedTecnicaSelected &&
                t.valueTecnica == this.tecnicaSeleccionada) ||
              (this.hasGroupedTecnicaSelected &&
                t.valueTecnica == this.specificTecnicaSeleccionadOfGroup)
          )
        )
          return;
        this.tecnicaSeleccionada = newVal[0].valueTecnica;
      }
    },

    // Si hay un nuevo grupo de técnicas seleccionadas, comprobamos que siga siendo correcto su valor
    hasGroupedTecnicaSelected(newVal, oldVal) {
      if (
        newVal &&
        !oldVal &&
        this.groupedTecnicas[this.tecnicaSeleccionada].length
      ) {
        this.specificTecnicaSeleccionadOfGroup =
          this.selectedGroupedTecnica[0].valueTecnica;
      }
    },

    // Actualizamos alto y ancho en caso de que se actualice el tamaño en cm2
    maxSizeForTamanoCm2(newVal, oldVal) {
      if (newVal && oldVal) {
        let sameArea = newVal.Area == oldVal.Area;
        let sameAlto = newVal.Alto == oldVal.Alto;
        let sameAncho = newVal.Ancho == oldVal.Ancho;
        if (sameArea && sameAlto && sameAncho) return;
      }

      if (this.infoTecnicaSeleccionada.tamanoCm2) {
        const defaultArea = newVal?.Area ?? 1;
        const isDtf3d = this.infoTecnicaSeleccionada?.valueTecnica == "Dtf3d";

        if (isDtf3d && defaultArea > 50) {
          this.widthTamanoCm2 = newVal?.Ancho ?? 1;
          this.heightTamanoCm2 = newVal?.Alto ?? 1;
          this.updateSizeCm2(50, "Area");
          return;
        }

        this.params.tamanoCm2Area = defaultArea;
        this.widthTamanoCm2 = newVal?.Ancho ?? 1;
        this.heightTamanoCm2 = newVal?.Alto ?? 1;
      }
    },

    // Actualizamos el número de colores si actualmente tiene puesto uno demasiado grande
    maxColores(newVal) {
      if (newVal < this.params.colores) this.params.colores = 1;
    },

    // Si se cambia el arrai de número de colores disponibles, y el color actual no esta incluido
    coloresDisponibles(newVal) {
      if (!newVal?.length) return;

      if (newVal.includes(this.params.colores)) return;

      this.params.colores = newVal[0];
    },

    numGajosDisponibles(newVal) {
      if (!this.infoTecnicaSeleccionada?.gajos || !newVal?.length) return;

      if (newVal.includes(this.params.gajos)) return;

      this.params.gajos = newVal[0];
    },

    "params.gajos": function (newVal) {
      const key = this.getGajosStorageKey(this.infoTecnicaSeleccionada?.valueTecnica);
      if (!key || newVal == null) return;

      this.$set(this.gajosByTecnica, key, newVal);
    },

    // Si se cambia el tamaño máximo de la zona para el conjunto de productos seleccionados, comprobamos que tenga un tamaño válido
    actualMaxValidSize(newVal) {
      if (!newVal?.text) return;

      if (
        newVal.Ancho > this.params.ancho ||
        newVal.Alto > this.params.alto ||
        !this.params.tamano
      ) {
        this.params.tamano = newVal?.text ?? "A8";
        this.params.maxWidth = this.tamanos[this.params.tamano].Ancho;
        this.params.maxHeight = this.tamanos[this.params.tamano].Alto;
      }
    },

    // Si se actualiza el listado de opciones, comprobamos que la opción seleccionada siga siendo válida
    filteredOptions(newVal) {
      if (!this.infoTecnicaSeleccionada.typeColor || !newVal?.length) {
        this.params.typeColor = null;
        return;
      }

      if (!newVal.some(p => p.Type == this.params.typeColor)) {
        this.params.typeColor = newVal[0].Type;
      }
    },

    // Si se actualiza la altura máxima, revisamos que tenga un valor correcto
    maxHeightSelectOption(newVal) {
      if (!newVal?.length) {
        this.params.maxHeightSelect = 100;
        return;
      }

      if (!newVal.includes(this.params.maxHeightSelect)) {
        this.params.maxHeightSelect = newVal[0];
      }
    },

    // En caso de que se actualice el número de caras, comprobamos que tengamos un valor valido
    numCarasAvaliblesArray(newVal) {
      if (!newVal?.length) return;

      if (
        this.params.numCaras &&
        newVal.some(v => v.value == this.params.numCaras)
      )
        return;

      this.params.numCaras = newVal[0].value;
    },

    // Recalculamos si el tamaño máximo es válido para el seleccionado actualmente
    actualMaxValidSizeNumDtf(newVal, oldVal) {
      if (!this.infoTecnicaSeleccionada.tamanoEstampadoNumerosDTF || !newVal) {
        this.params.tamanoEstampadoNumerosDTF = null;
        return;
      }

      if (newVal == oldVal) return;

      let actualSelected = this.filteredOptions.find(
        o => o.value == this.params.tamanoEstampadoNumerosDTF
      );

      if (!actualSelected || (newVal && newVal.value != actualSelected.value)) {
        this.params.tamanoEstampadoNumerosDTF =
          newVal?.value ?? this.filteredOptions[0].value;
      }
    },

    // IMPORTANTE: si cualquier parámetro activo se cambia, se lanza el calculo del precio actual, con la nueva configuración
    params: {
      deep: true,
      async handler() {
        this.calculateActualTecnicaDebounced();
      }
    },

    // Si varia las opciones de Digital, comprobamos que sigamos teniendo un valor válido
    actualPositionSizeDigitalOptions(newVal) {
      if (newVal?.length) {
        if (newVal.some(p => p.code == this.digitalTam)) return;

        if (this.maxValidSizeDigital?.value) {
          this.digitalTam = this.maxValidSizeDigital.value;
        } else {
          this.digitalTam = newVal[0].code;
        }
      }
    },

    // Comprobamos que tenemos un valor valido para doming
    avalibleSizeDoming(newVal) {
      if (newVal?.length) {
        if (newVal.some(p => p.code == this.params?.domingTamCode)) return;

        this.params.domingTamCode = newVal[0].code;
      }
    },

    //  Comprobamos que el tipo de termograbado sigue siendo valido
    avalibleTermograbado(newVal) {
      if (newVal?.length) {
        if (newVal.some(t => t.value == this.params.typeTermograbado)) return;

        this.params.typeTermograbado = newVal[0].value;
      }
    },

    // Si cuando se actualizan las tintas, intentamos seguir el siguiente orden
    // - Si tiene una forzada intentamos ponerla
    // - Sino, intentamos dejar la que ya estuviese puesta
    // - Sino, intentamos poner la de sin tinta
    // - Sino, ponemos la que sea
    allTintas(newVal) {
      if (!newVal?.length) return;

      const availableValues = new Set(newVal.map(t => t.value));
      const forced = this.forzarTipoTinta;

      if (forced && forced != 5 && availableValues.has(forced)) {
        if (this.params.idTipoTinta !== forced) {
          this.params.idTipoTinta = forced;
        }
        return;
      }

      if (availableValues.has(this.params.idTipoTinta)) return;

      if (availableValues.has(5)) {
        this.params.idTipoTinta = 5;
        return;
      }

      const first = newVal[0].value;
      this.params.idTipoTinta = first;
    },

    idOfActualHasDesembolsadoPack(newVal, oldVal) {
      if (newVal == this.zona.id && oldVal != this.zona.id) {
        this.calculateActualTecnicaDebounced();
      }
    },

    //  Si se cambia el número de unidades totales, debemos forzar una actualización de precios, y recalcular la técnica seleccionada aunque no se hayan modificado los parámetros
    totalUnidades(newVal, oldVal) {
      if (newVal <= 1) {
        if(oldVal > 0) {
          this.removeZone();
        }

        return
      }

      if (newVal == oldVal) return;

      this.calculateActualTecnicaDebounced(true);
    },

    selected(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.addInfoTecnicaActualZone({info: this.infoTecnicaSeleccionada, zone: this.zona});
      }
    },

    // Se crea este watch, para actualizar el valor de la técnica actual en el store, con esto conseguimos poder obtener el tamaño real máximo para la zona, para escalar correctamente el logo
    async zona(newVal, oldVal) {
      if (!newVal || !newVal.Posicion) {
        this.addInfoTecnicaActualZone({});
        return;
      }

      if (newVal.Posicion == oldVal?.Posicion) {
        return;
      }

      this.addInfoTecnicaActualZone({info: this.infoTecnicaSeleccionada, zone: newVal});
    },

    // Si se cambia la técnica seleccionada, debemos volver a obtener los parámetros que sean necesarios para la técnica, resetear los campos correspondientes y forzamos una actualización de precios
    async infoTecnicaSeleccionada(newVal, oldVal) {
      if (!newVal) {
        this.addInfoTecnicaActualZone({});
        return;
      }

      if (newVal?.valueTecnica == oldVal?.valueTecnica) return;

      const oldKey = this.getGajosStorageKey(oldVal?.valueTecnica);
      if (oldKey && oldVal?.gajos && this.params.gajos != null) {
        this.$set(this.gajosByTecnica, oldKey, this.params.gajos);
      }

      const newKey = this.getGajosStorageKey(newVal?.valueTecnica);
      if (newKey && newVal?.gajos) {
        if (Object.hasOwn(this.gajosByTecnica, newKey)) {
          this.params.gajos = this.gajosByTecnica[newKey];
        } else if (this.numGajosDisponibles.length) {
          this.params.gajos = this.numGajosDisponibles[0];
        }
      }

      if (newVal.valueTecnica == "DTFNumeros") {
        await this.fetchOptionsNumerosDtf();
      }

      if (newVal.valueTecnica == "TransferNumeros") {
        await this.fetchOptionsNumerosTransfer();
      }

      if (
        newVal.tamanocm2Digital &&
        !this.actualPositionSizeDigitalOptions?.length
      ) {
        await this.fetchSizeDigitalOptions(this.zona.Posicion);
      } else if (this.actualPositionSizeDigitalOptions?.length) {
        if (this.maxValidSizeDigital.value) {
          this.digitalTam = this.maxValidSizeDigital.value;
        } else {
          this.digitalTam =
            this.actualPositionSizeDigitalOptions[0].code;
        }
      }

      if (newVal.caras && this.numCarasAvaliblesArray.length) {
        this.params.numCaras = this.numCarasAvaliblesArray[0].value;
      }

      if (newVal.dobleBaseSerigrafia && !this.showOpcionesAvanzadas) {
        this.showOpcionesAvanzadas = true;
      }

      if (newVal.tamanoCm2Doming && this.avalibleSizeDoming.length) {
        if (this.maxValidSizeDoming?.value) {
          this.params.domingTamCode = this.maxValidSizeDoming.value;
        } else {
          this.params.domingTamCode = this.avalibleSizeDoming[0].code;
        }
      }

      if (newVal.typeTermograbado && this.avalibleTermograbado.length) {
        this.params.typeTermograbado = this.avalibleTermograbado[0].value;
      }

      if (
        newVal.idTipoTinta &&
        this.allTintas.length &&
        !this.allTintas.some(t => t.value == this.params.idTipoTinta)
      ) {
        this.params.idTipoTinta = this.allTintas[0].value;
      }

      if (newVal.idTamImpresion) {
        this.params.idTamImpresion =
          this.actualMaxValidSizeImpresionDirecta?.value ?? 4;
      }

      let TransferDigitalMetrosLinealesStmInfo =  configTecnicasUtil.getTecnica("TransferDigitalMetrosLinealesStm")
      let DtfUvInfo = configTecnicasUtil.getTecnica("DtfUv")

      if (newVal.MetrosLineales && newVal.valueTecnica == TransferDigitalMetrosLinealesStmInfo.valueTecnica) {
        this.seEnvianMetrosLineales = true;
        this.forceEnviarMetrosLineales = true;
      }
      else if (newVal.valueTecnica == DtfUvInfo.valueTecnica)
      {
        this.seEnvianMetrosLineales = false;
        this.forceEnviarMetrosLineales = false;
      }
      else
      {
        this.seEnvianMetrosLineales = false;
        this.forceEnviarMetrosLineales = false;
      }

      this.calculateActualTecnica(true);
      this.addInfoTecnicaActualZone({info: newVal, zone: this.zona});
    },

    // Si se indica que debemos poner metros lineales provocaremos una actualización de precios forzosa
    seEnvianMetrosLineales() {
      this.calculateActualTecnica();
    }
  },

  mounted() {
    // Forzamos a seleccionar una primera técnica
    if (!this.tecnicaSeleccionada && this.tecnicas?.length) {
      let findTecnicaRecomendada = this.tecnicas.find(
        t => t.isTecnicaRecomendada
      );

      if (findTecnicaRecomendada) {
        if (!findTecnicaRecomendada?.groupTecnica) {
          this.tecnicaSeleccionada = findTecnicaRecomendada.valueTecnica;
        } else {
          this.tecnicaSeleccionada = findTecnicaRecomendada.groupTecnica;
          this.specificTecnicaSeleccionadOfGroup =
            this.selectedGroupedTecnica?.[0]?.valueTecnica;
        }
      } else if (!this.tecnicas[0]?.groupTecnica) {
        this.tecnicaSeleccionada = this.tecnicas[0].valueTecnica;
      } else {
        this.tecnicaSeleccionada = this.tecnicas[0].groupTecnica;
        this.specificTecnicaSeleccionadOfGroup =
          this.selectedGroupedTecnica?.[0]?.valueTecnica;
      }
    }
  },
  beforeDestroy() {
    this.removeZone();
  },
  methods: {
    ...mapActions("carrito", ["calcularPrecios", "deleteReprocesoById", "addInfoTecnicaActualZone"]),
    ...mapActions("modelo", ["addAlert"]),
    ...mapActions("config", [
      "fetchOptionsNumerosDtf",
      "fetchOptionsNumerosTransfer",
      "fetchSizeDigitalOptions"
    ]),
    ...mapActions('design', [
      "deleteZoneCustomDesign"
    ]),
    // Método para buscar la mejor opción dado unas dimensiones dentro del tamaño para impresion digital directa
    checkBestOptionImpresionDigital(width, height) {
      let bestOption = null;
      const actualcm2 = (width * height) / 100;

      // Debemos buscar el mejor de actualPositionSizeDigitalOptions
      // Para ello recorreremos todos los elementos, buscando cual es el área más próxima al área del logo, siempre por debajo
      this.actualPositionSizeDigitalOptions.forEach(opt => {
        const hasDimensions = opt.width && opt.height;

        if (hasDimensions) {
          if (opt.width >= width && opt.height >= height) {
            if (!bestOption || Math.abs(opt.value - bestOption.value) > Math.abs(opt.value - actualcm2)) {
              bestOption = opt;
            }
          }
        } else {
          // En caso de que no tenga dimensiones (stamina), simplemente comparamos por area
          if (opt.value >= actualcm2) {
            if (!bestOption || Math.abs(opt.value - bestOption.value) > Math.abs(opt.value - actualcm2)) {
              bestOption = opt;
            }
          }
        }
      });
      return bestOption
    },
    // Método para actualizar el tamaño en el 3D si es necesario tras un cambio de tamaño
    async updateScale3DLogo(target, dimension = 'width') {
      const info3D = this.actualDesignZone?.img3DInfo;

      // Validaciones de seguridad
      if (!this.actualDesignZone || !info3D || !target) return;
      if (!info3D.width || !info3D.height) {
          console.warn("El objeto 3D no tiene dimensiones en píxeles (width/height)");
          return;
      }

      if (this.debounceScale3D) {
        clearTimeout(this.debounceScale3D);
      }

      this.debounceScale3D = setTimeout(async () => {
         // 1. Obtener valor ACTUAL (mm) para evitar actualizaciones innecesarias
        // Usamos info3D.widthMm / heightMm que ya tienes calculados en el objeto
        const currentValMm = dimension === 'width' ? info3D.widthMm : info3D.heightMm;
        
        // Margen de error pequeño (0.5mm) para evitar bucles infinitos por decimales
        if (Math.abs(target - currentValMm) < 0.5) {
            // console.log("Diferencia despreciable, no actualizamos 3D");
            return;
        }

        // 2. CALCULAR LA BASE "REAL" (ESCALA 1) USANDO PIXELES
        // Esto nos dice: "¿Cuánto mediría esta imagen de 200px si la escala fuera 1.0?"
        const dimensionesBase = estimateRealMmDimensions(
            this.activeZone3D,
            parseFloat(info3D.width ?? info3D?.currentDimensions?.width),   // "200" -> 200 (Original Px)
            parseFloat(info3D.height ?? info3D?.currentDimensions?.height),  // "200" -> 200 (Original Px)
            1,                          // <--- FORZAMOS ESCALA 1
            this.activeZoneMaxSize.Ancho,
            this.activeZoneMaxSize.Alto
        );

        // Elegimos la dimensión base correcta
        const tamanoBaseMm = dimension === 'width' ? dimensionesBase.widthMm : dimensionesBase.heightMm;

        console.log(`
          DEBUG ESCALA:
          - Pixeles Originales: ${info3D.width}x${info3D.height}
          - Base Mm (al 100%): ${tamanoBaseMm}mm
          - Escala Actual: ${info3D.scale}
          - Objetivo: ${target}mm
        `);

        // 3. CALCULAR PASOS
        const pasosNecesarios = calcularIncrementoEscala(
            tamanoBaseMm,   // Referencia absoluta
            info3D.scale,   // Punto de partida
          target,          // Destino
            info3D.mode == "TEXT" ? 0.01 : 0.02
        );
        console.log(`--> Aplicando ${pasosNecesarios} pasos al 3D`);

        if (pasosNecesarios === 0) return;

        // 4. EJECUTAR
        try {
          await scaleLogo(info3D, this.activeZone3D, pasosNecesarios);
        } catch(err) {
          console.log("ERROR SCALANDO", err)
        }
      }, 300);  
      

     
    },

    getGajosStorageKey(valueTecnica) {
      if (!valueTecnica || typeof valueTecnica !== "string") return null;

      if (valueTecnica.startsWith("TransferDigital")) return "TransferDigitalStm";

      if (valueTecnica.startsWith("TransferSerigrafico")) return "TransferSerigraficoStm";

      if (valueTecnica.startsWith("Serigrafia")) return "Serigrafia";

      return null;
    },
  

    // Función para eliminar el diseño actual
    removeCustomDesign() {
      this.deleteZoneCustomDesign({
          id: this.zona?.id,
          posicion: this.zona.Posicion
        });
    },
    // Método para formatear una descripción de zona
    formatDescription(value) {
      return (
        this.zonasDescription.find(z => z.Posicion == value)?.Descripcion ?? ""
      );
    },

    getEffectiveAreaMax(max = this.maxSizeForTamanoCm2) {
      if (!max?.Area) return null;

      // DTF3D tiene cap funcional de 50cm2 aunque el maximo geometrico de la zona sea mayor.
      if (this.infoTecnicaSeleccionada?.valueTecnica == "Dtf3d") {
        return Math.min(max.Area, 50);
      }

      return max.Area;
    },

    // Normaliza dimensiones float a mm enteros candidatos y devuelve el mejor resultado final.
    // Modo normal: elige el candidato mas cercano a los valores calculados.
    // Modo preferBelowAreaMax: prioriza el mayor area <= areaMax; si no existe, usa el menor exceso por arriba.
    // Siempre respeta limites de zona (max.Ancho / max.Alto) y evita valores menores de 1mm.
    resolveRoundedCm2Dimensions(newW, newH, max, options = {}) {
      const { preferBelowAreaMax = false, areaMax = null } = options;
      const maxW = Math.max(1, Math.floor(max?.Ancho ?? Number.MAX_SAFE_INTEGER));
      const maxH = Math.max(1, Math.floor(max?.Alto ?? Number.MAX_SAFE_INTEGER));

      // Probamos las 3 aproximaciones tipicas por eje para no perder una combinacion valida por redondeo.
      const rawW = [Math.floor(newW), Math.round(newW), Math.ceil(newW)];
      const rawH = [Math.floor(newH), Math.round(newH), Math.ceil(newH)];
      const candidateMap = new Map();

      for (const w of rawW) {
        for (const h of rawH) {
          // Cada candidato queda acotado al rango permitido de la zona.
          const cw = Math.max(1, Math.min(w, maxW));
          const ch = Math.max(1, Math.min(h, maxH));
          candidateMap.set(`${cw}-${ch}`, { width: cw, height: ch });
        }
      }

      const candidates = Array.from(candidateMap.values()).map(c => ({
        ...c,
        area: (c.width * c.height) / 100,
        distance: Math.abs(c.width - newW) + Math.abs(c.height - newH)
      }));

      if (!candidates.length) {
        // Salvaguarda: si algo falla, usamos el redondeo clasico con limites.
        const width = Math.max(1, Math.min(Math.round(newW), maxW));
        const height = Math.max(1, Math.min(Math.round(newH), maxH));
        return {
          width,
          height,
          area: (width * height) / 100
        };
      }

      if (!preferBelowAreaMax || !areaMax) {
        // Modo normal: prioriza fidelidad respecto al valor calculado (distancia minima).
        return candidates.sort((a, b) => a.distance - b.distance)[0];
      }

      // Modo maximo: elegimos el mayor area que no sobrepase el limite.
      const under = candidates
        .filter(c => c.area <= areaMax + 0.0001)
        .sort((a, b) => {
          if (b.area !== a.area) return b.area - a.area;
          return a.distance - b.distance;
        });

      if (under.length) {
        return under[0];
      }

      // Fallback: no existe alternativa por debajo (discretizacion), usamos la menor por arriba.
      return candidates.sort((a, b) => {
        const diffA = Math.abs(a.area - areaMax);
        const diffB = Math.abs(b.area - areaMax);
        if (diffA !== diffB) return diffA - diffB;
        return a.distance - b.distance;
      })[0];
    },

    // Wrapper con debounce para el campo Area (evita ejecuciones con valores parciales al escribir)
    updateSizeCm2Debounced(value, type) {
        clearTimeout(this.debounceArea);
        this.debounceArea = setTimeout(() => {
            this.updateSizeCm2(value, type);
        }, 400);
    },

    // Actualizar tamaño de cm2
    updateSizeCm2(value, type) {
        const val = parseFloat(value);
        if (!val || val <= 0) return;
        const max = this.maxSizeForTamanoCm2;
        if (!max) return;
      const maxArea = this.getEffectiveAreaMax(max);

        // Detectamos si hay logo 3D con tamaño conocido en mm
        const info3D = this.actualDesignZone?.img3DInfo;
        const hasLogo3D = !!(info3D?.widthMm && info3D?.heightMm);

        // Ratio: con logo 3D usamos el ratio capturado al cargarlo (estable, no varía con escalados);
        // sin logo, del estado actual como fallback
        const logoRatio = hasLogo3D
            ? (this.logoRatio3D ?? (info3D.widthMm / info3D.heightMm))
            : (this.widthTamanoCm2 && this.heightTamanoCm2
                ? this.widthTamanoCm2 / this.heightTamanoCm2
                : 1);

        // Partimos de los valores actuales como base
        let newW = this.widthTamanoCm2 || max.Ancho;
        let newH = this.heightTamanoCm2 || max.Alto;

        if (type === 'Area') {
            // Con logo: ratio del logo. Sin logo: ratio natural de la zona (max.Ancho/max.Alto),
            // ignorando los valores manuales que el usuario pudo haber puesto en Ancho/Alto
            const ratioParaArea = hasLogo3D ? logoRatio : (max.Ancho / max.Alto);
            newH = Math.sqrt((val * 100) / ratioParaArea);
            newW = newH * ratioParaArea;
        } else if (type === 'Ancho') {
            newW = val;
            if (hasLogo3D) newH = newW / logoRatio;
            // Sin logo 3D: Alto no cambia → inputs independientes
        } else if (type === 'Alto') {
            newH = val;
            if (hasLogo3D) newW = newH * logoRatio;
            // Sin logo 3D: Ancho no cambia → inputs independientes
        }

        const maxByType =
          type === 'Area'
            ? maxArea
            : (type === 'Ancho' ? max.Ancho : max.Alto);
        const tryingToSetMax = !!maxByType && val >= (maxByType - 0.0001);

        // Límites: con logo o Area → escalar proporcionalmente al máximo; Ancho/Alto sin logo → clampear solo la dimensión editada
        if (newW > max.Ancho || newH > max.Alto) {
            if (hasLogo3D || type === 'Area') {
                const scale = Math.min(max.Ancho / newW, max.Alto / newH);
                newW = Math.floor(newW * scale);
                newH = Math.floor(newH * scale);
            } else if (type === 'Ancho') {
                newW = max.Ancho;
            } else if (type === 'Alto') {
                newH = max.Alto;
            }
        }

            // Solo al intentar el maximo: si por ratio/redondeo quedamos por encima, bajar al primer valido por debajo.
            if (tryingToSetMax && maxArea) {
              const resolved = this.resolveRoundedCm2Dimensions(newW, newH, max, {
                preferBelowAreaMax: true,
                areaMax: maxArea
              });

              this.widthTamanoCm2 = resolved.width;
              this.heightTamanoCm2 = resolved.height;
              this.params.tamanoCm2Area = parseFloat(resolved.area.toFixed(2));
              return;
            }

            // Comportamiento actual para tamaños por debajo del maximo
            this.widthTamanoCm2 = Math.round(newW);
            this.heightTamanoCm2 = Math.round(newH);
            this.params.tamanoCm2Area = parseFloat(((this.widthTamanoCm2 * this.heightTamanoCm2) / 100).toFixed(2));
    },

    // Método para actualizar ancho y alto respecto al tamaño seleciconado
    async actualGetMedidasByTamano() {
      var result = this.dinADimension;
      const currentW = this.params.maxWidth;
      const currentH = this.params.maxHeight;

      // Validación inicial
      if (!currentW || !currentH) {
        this.params.maxWidth = Math.round(result.Ancho);
        this.params.maxHeight = Math.round(result.Alto);
        return;
      }

      // Calculamos la escala exacta (con decimales) para que ajuste perfecto
      const scaleX = result.Ancho / currentW;
      const scaleY = result.Alto / currentH;
      const scale = Math.min(scaleX, scaleY);

      // Aplicamos la escala y REDONDEAMOS al final
      this.params.maxWidth = Math.round(currentW * scale);
      this.params.maxHeight = Math.round(currentH * scale);

      await this.updateTamanoByHeightAndWidth()
    },

    // Método para actualizar el tamaño respecto al ancho y alto
    async updateTamanoByHeightAndWidth() {
      let tamañoCompatible = null;
      let diferenciaMinima = Infinity;

      const listAvalibleTam = Object.entries(this.tamanos);

      for (const [tamaño, dimensiones] of listAvalibleTam) {
        if (
          dimensiones.Ancho >= this.params.maxWidth &&
          dimensiones.Alto >= this.params.maxHeight
        ) {
          const diferencia =
            dimensiones.Ancho -
            this.params.maxWidth +
            (dimensiones.Alto - this.params.maxHeight);
          if (diferencia < diferenciaMinima) {
            diferenciaMinima = diferencia;
            tamañoCompatible = tamaño;
          }
        }
      }

      if(tamañoCompatible == null) {
        console.warn("No se ha encontrado un tamaño compatible para las dimensiones indicadas");
        const [tamano, ] = listAvalibleTam[0];
        tamañoCompatible = tamano;
      }

      if(this.params.tamano != tamañoCompatible)
        this.params.tamano = tamañoCompatible;

      await this.updateScale3DLogo(this.params.maxWidth, 'width');
      await this.updateScale3DLogo(this.params.maxHeight, 'height');
    },

    // Metodo para emitir el evento de borrado de la zona
    removeZone() {
      if (this.carrito.reprocesos?.length <= 1) {
        this.addInfoTecnicaActualZone({}) 
      }

      this.deleteReprocesoById(this.zona.id);
      
      this.$emit("removeZone");
    },

    // Función wrapper de calculateActualTecnica para crear el debounce de 700ms
    calculateActualTecnicaDebounced(noCompareOldParams) {
      clearTimeout(this.debouncedCalculate);
      this.debouncedCalculate = setTimeout(async () => {
        await this.calculateActualTecnica(noCompareOldParams);
      }, 700);
    },

    // Función para calcular el precio de la técnica actual
    async calculateActualTecnica(noCompareOldParams = false) {
      
        let param = { ...this.params, digitalTam: this.digitalTam };
        let resultParam = {};

        // Se van a comprobar que campos tenemos activos en infoTecnicaSeleccionada
        // todos aquellos que sean true, se hara la comproción que corresponda y se añadirá
        // a los atributos a enviar a la api para el calculo de precio

        let actualTecnicaValue = this.infoTecnicaSeleccionada.valueTecnica;

        let warningTech = []

        // Comprobación unidades mínimas
        const isSublimacion = actualTecnicaValue.startsWith("SublimacionStm");
        const isSerigrafia =
          !isSublimacion && actualTecnicaValue.startsWith("SerigrafiaStm");
        if (isSublimacion || isSerigrafia) {
          let tecnicaInfo = this.getFilteredTecnicasExtra(
            this.zona.Posicion,
            isSublimacion
              ? "Sublimacion"
              : isSerigrafia
                ? "Serigrafia"
                : actualTecnicaValue.replace("Stm", "")
          );

          if (tecnicaInfo?.MinUnit) {
            if (this.totalUnidades < tecnicaInfo.MinUnit) {
              this.addAlert({
                title: this.$t("errores.alert.errorMinUnitTitleDialog", {
                  modelo: this.modelCode
                }),
                code: "errorMinUnit",
                minUnit: tecnicaInfo?.MinUnit ?? 0
              });
              return;
            }
          }
        }

        // Comprobaciones de maxWidth y maxHeight
        if (
          this.infoTecnicaSeleccionada.maxWidth &&
          this.infoTecnicaSeleccionada.maxHeight &&
          !this.infoTecnicaSeleccionada.noShowHeightAndWidth
        ) {
          if (!param.maxWidth || !param.maxHeight) {
            console.warn("No se han definido las medidas");
            if (!this.tamanosArray.length) {
              console.error("La zona es muy pequeña, y no puedo inventarmelo");
              return;
            }

            this.params.tamano =
              this.tamanosArray[this.tamanosArray.length - 1];
          }

          var excedido = this.medidasMaximas({
            posicion: this.zona.Posicion,
            xaxis: param.maxWidth,
            yaxis: param.maxHeight
          });
          let size = this.dinADimension;
          if (excedido.length > 0) {
            
            let tecnica = this.groupedTecnicasArray.find(
              v => v.valueTecnica == this.tecnicaSeleccionada
            );
            this.addAlert({
              title:
                this.$t("errores.alert.errorTamEstampacionTitleDialog") +
                " (" +
                tecnica.label +
                ")",
              listProduct: excedido,
              code: "errorTamEstampacion",
              tamEstX: size?.Ancho,
              tamEstY: size?.Alto,
              zone: this.zona,
              tamEstampacion: this.params.tamano
            });
            
            warningTech.push({
              listProduct: excedido,
              code: "errorTamEstampacion",
              tamEstX: size?.Ancho,
              tamEstY: size?.Alto,
              zone: this.zona,
              tamEstampacion: this.params.tamano
            })
          }
          else
          {
            // Puede llegar a ocurrir, que se supere en maxWidth y maxHeight el tamaño del dinA seleccionado, por lo que deberíamos poner el warning tambien
            if(size?.Ancho < param.maxWidth || size?.Alto < param.maxHeight)
            {
              warningTech.push({
                listProduct: excedido,
                code: "errorTamEstampacionDinA",
                tamEstX: size?.Ancho,
                tamEstY: size?.Alto,
                zone: this.zona,
                tamEstampacion: this.params.tamano
              })
            }
          }

          resultParam.maxWidth = param.maxWidth;
          resultParam.maxHeight = param.maxHeight;
        }

        // Calculo de prendasBlanco, prendasClaro y prendasOscuro para las técnicas que le sean necesario
        if (
          this.infoTecnicaSeleccionada.prendasBlanco &&
          this.infoTecnicaSeleccionada.prendasClaro &&
          this.infoTecnicaSeleccionada.prendasOscuro
        ) {
          let hasSpecificZone =
            this.infoZonasFondo &&
            this.infoZonasFondo.AvalibleColors &&
            this.infoZonasFondo.AvalibleColors.length > 0;

          resultParam.prendasBlanco = 0;
          resultParam.prendasClaro = 0;
          resultParam.prendasOscuro = 0;

          this.carrito.productos.forEach(e => {
            let productInfo = this.modelInfoFromCatalog.products[e.id];
            if (productInfo == null) return;

            if (hasSpecificZone) {
              let actualColorZone = this.infoZonasFondo.AvalibleColors.find(
                c => c.Color == e.color
              );

              if (actualColorZone) {
                if (actualColorZone.isBlanco) {
                  resultParam.prendasBlanco += parseInt(e.cantidad);
                } else if (actualColorZone.isClaro) {
                  resultParam.prendasClaro += parseInt(e.cantidad);
                } else if (actualColorZone.isOscuro) {
                  resultParam.prendasOscuro += parseInt(e.cantidad);
                }
                return;
              }
            }

            if (productInfo.COLOR == "01") {
              resultParam.prendasBlanco += parseInt(e.cantidad);
            } else if (!this.listColorFondo[productInfo.COLOR] == 0)
              resultParam.prendasClaro += parseInt(e.cantidad);
            else resultParam.prendasOscuro += parseInt(e.cantidad);

            if (
              !resultParam.prendasClaro &&
              !resultParam.prendasBlanco
            ) {
              console.warn(
                "No se han encontrado unidades para ninguna combinación"
              );
              return;
            }
          });
        }

        if (this.infoTecnicaSeleccionada.idTipoTinta) {
          if (!param.idTipoTinta) {
            console.warn("No se han encontrado un id de tinta valido");
            return;
          }

          resultParam.idTipoTinta = param.idTipoTinta;
        }

        if (this.infoTecnicaSeleccionada.hasPlanchado) {
          resultParam.hasPlanchado = param.hasPlanchado ?? false;
        }

        if (this.infoTecnicaSeleccionada.tintaNegra) {
          resultParam.tintaNegra = param.tintaNegra ?? false;
        }

        if (this.infoTecnicaSeleccionada.colores) {
          if (!param.colores || param.colores < 1) {
            console.warn("No se han encontrado número de colores correcto");
            return;
          }
          resultParam.colores = param.colores;

          if(this.logoNumColor && this.logoNumColor != param.colores) {
            warningTech.push({
              code: "NotSameNumColorThanLogo",
              numColoresLogo: this.logoNumColor,
              numColoresSeleccionados: param.colores
            });
          }

          if (
            this.infoTecnicaSeleccionada.valueTecnica.includes("TransferSerigrafico") &&
            !this.isZoneOnlyBlanco
          ) {
            resultParam.colores++;
          }
        }

        if (this.infoTecnicaSeleccionada.tamano) {
          if (
            this.infoTecnicaSeleccionada.MetrosLineales &&
            this.seEnvianMetrosLineales
          ) {
            resultParam.tamano = "AML";
          } else {
            if (!param.tamano) {
              console.warn("No se han encontrado un tamano válido");
              return;
            }
            resultParam.tamano = param.tamano;
          }
        }

        if (actualTecnicaValue == "DtfUv" && this.seEnvianMetrosLineales) {
          resultParam.tamano = "AML";
        }

        if (this.infoTecnicaSeleccionada.nreprocesos) {
          resultParam.nreprocesos = this.numReprocesosSerigrafiaOrTransfer ?? 0;
        }

        if (this.infoTecnicaSeleccionada.esPrendaPackUno && this.hasPackUno) {
          let loadPlanchado =
            this.hasPackUno &&
            (!this.idOfActualHasDesembolsadoPack ||
              this.zona.id == this.idOfActualHasDesembolsadoPack);
          if (loadPlanchado) resultParam.esPrendaPackUno = loadPlanchado;
        }

        if (this.infoTecnicaSeleccionada.tintas) {
          resultParam.tintas = "blanca";
        }

        if (this.infoTecnicaSeleccionada.puntadas) {
          if (!param.puntadas || param.puntadas < 1) {
            console.warn(
              "No se han encontrado un proporcionado un número de puntadas válido"
            );
            return;
          }

          resultParam.puntadas = param.puntadas;
        }

        if (this.infoTecnicaSeleccionada.productos) {
          resultParam.productos = Object.keys(this.quantityByColor).reduce(
            (acc, cur) => acc + this.quantityByColor[cur] + "::" + cur + ";",
            ""
          );
        }

        if (this.infoTecnicaSeleccionada.fondo) {
          resultParam.fondo = "Claro"; // Impresión directa siempre claro
        }

        if (this.infoTecnicaSeleccionada.MetrosLineales) {
          if (this.seEnvianMetrosLineales) {
            resultParam.MetrosLineales = param.MetrosLineales;
          }
        }

        if (this.infoTecnicaSeleccionada.dobleNumero) {
          resultParam.dobleNumero = param.dobleNumero;
        }

        if (this.infoTecnicaSeleccionada.cortahilos) {
          resultParam.cortahilos = param.cortahilos;
        }

        if (this.infoTecnicaSeleccionada.idTamImpresion) {
          let resultFind = this.tamanosImpresionDirecta.find(
            t => t.value == param.idTamImpresion
          );
          let xaxis = resultFind.Ancho;
          let yaxis = resultFind.Alto;

          let excedido = this.medidasMaximas({
            posicion: this.zona.Posicion,
            xaxis,
            yaxis
          });
          if (excedido && excedido.length > 0) {
            this.addAlert({
              title:
                this.$t("errores.alert.errorTamEstampacionTitleDialog") +
                " (" +
                this.$t("tecnicas.IMPRESIÓN DIRECTA") +
                ")",
              listProduct: excedido,
              code: "errorTamEstampacion",
              tamEstX: xaxis,
              tamEstY: yaxis,
              zone: this.zona,
              tamEstampacion: resultFind?.text
            });

            warningTech.push({
              listProduct: excedido,
              code: "errorTamEstampacion",
              tamEstX: xaxis,
              tamEstY: yaxis,
              zone: this.zona,
              tamEstampacion: this.params.tamano
            })
          }

          resultParam.idTamImpresion = param.idTamImpresion;
        }

        if (this.infoTecnicaSeleccionada.tamanoEstampadoNumerosDTF) {
          let actualSelected = this.filteredOptions.find(
            o => o.value == param.tamanoEstampadoNumerosDTF
          );

          if (!actualSelected) {
            console.warn(
              "No se ha encontrado el tamaño seleccionado (numeros)"
            );
            return;
          }

          if (
            !this.actualMaxValidSizeNumDtf ||
            actualSelected.Alto > this.actualMaxValidSizeNumDtf.Alto ||
            actualSelected.Ancho > this.actualMaxValidSizeNumDtf.Ancho
          ) {
            this.addAlert({
              title:
                this.$t("errores.alert.errorTamEstampacionTitleDialog") +
                " (" +
                this.$t("tecnicas.NUMEROS-DTF") +
                ")",
              listProduct: [],
              code: "errorTamEstampacion",
              tamEstX: actualSelected.Ancho,
              tamEstY: actualSelected.Alto,
              zone: this.zona,
              tamEstampacion: param.tamanoEstampadoNumerosDTF
            });

           warningTech.push({
              listProduct: excedido,
              code: "errorTamEstampacion",
              tamEstX: actualSelected.Ancho,
              tamEstY: actualSelected.Alto,
              zone: this.zona,
              tamEstampacion: this.params.tamano
            })
          }

          if (actualSelected.minimum > this.totalUnidades) {
            this.addAlert({
              code: "errorMin",
              minUnit: actualSelected.minimum ?? 0
            });
            return;
          }

          if (
            this.infoTecnicaSeleccionada.maxWidth &&
            this.infoTecnicaSeleccionada.maxHeight
          ) {
            resultParam.maxWidth = actualSelected.Ancho;
            resultParam.maxHeight = actualSelected.Alto;
          }

          if (!param.tamanoEstampadoNumerosDTF || !actualSelected) {
            console.warm("No tamaño especificado para DTF");
            return;
          }

          resultParam.tamanoEstampadoNumerosDTF =
            param.tamanoEstampadoNumerosDTF;
        }

        if (this.infoTecnicaSeleccionada.disenoEspecial) {
          resultParam.disenoEspecial = param.disenoEspecial;
        }

        if (this.infoTecnicaSeleccionada.coloresImprDir) {
          resultParam.coloresImprDir = JSON.stringify(this.quantityByColor);
        }

        if (this.infoTecnicaSeleccionada.typeColor) {
          resultParam.typeColor = param.typeColor;
        }

        if (this.infoTecnicaSeleccionada.maxHeightSelect) {
          resultParam.maxHeight = param.maxHeightSelect;
        }

        if (this.infoTecnicaSeleccionada.isTransferDigital) {
          resultParam.isTransferDigital = param.isTransferDigital;
        }

        if (this.infoTecnicaSeleccionada.isTransferSerigrafico) {
          resultParam.isTransferSerigrafico = param.isTransferSerigrafico;
        }

        if (
          this.infoTecnicaSeleccionada.caras ||
          this.infoTecnicaSeleccionada.specificCaras
        ) {
          resultParam.caras = param.numCaras;

          if (
            !this.numCarasAvaliblesArray.some(v => v.value == resultParam.caras)
          ) {
            console.warn("Parámetro no valido de caras", resultParam.caras);
            return;
          }
        }

        if (this.infoTecnicaSeleccionada.dobleBaseSerigrafia) {
          resultParam.dobleBaseSerigrafia = param.dobleBaseSerigrafia;
        }

        if (this.infoTecnicaSeleccionada.gajos) {
          resultParam.gajos = param.gajos;
        }

        if (this.infoTecnicaSeleccionada.tamanocm2Digital) {
          if (!param.digitalTam) {
            console.warn("No se ha seleccionado un tamaño digital");
            return;
          }

          if (
            !this.actualPositionSizeDigitalOptions.some(
              p => p.code == param.digitalTam
            )
          ) {
            console.warn("Tamaño digital no valido");
            return;
          }

          let actualSize = this.actualPositionSizeDigitalOptions.find(
            t => t.code == param.digitalTam
          );

          if (
            actualSize.value > this.maxValidSizeDigital?.upperValue ||
            (actualSize.height && actualSize.height > param.heightTamanoCm2) ||
            (actualSize.width && actualSize.width > param.widthTamanoCm2)
          ) {
            this.addAlert({
              title:
                this.$t("errores.alert.errorTamEstampacionTitleDialog") +
                " (" +
                this.$t("tecnicas.DIGITAL") +
                ")",
              listProduct: [],
              code: "errorTamEstampacion",
              // tamEstX: actualSelected.Ancho,
              // tamEstY: actualSelected.Alto,
              zone: this.zona,
              tamEstampacion: actualSize.value
            });

            warningTech.push({
              listProduct: [],
              code: "errorTamEstampacion",
              // tamEstX: actualSelected.Ancho,
              // tamEstY: actualSelected.Alto,
              zone: this.zona,
              tamEstampacion: actualSize.value
            })
          }

          resultParam.tamanocm2Digital = param.digitalTam;
        }

        if (this.infoTecnicaSeleccionada.tamanoCm2Doming) {
          if (!param.domingTamCode) {
            console.warn("No se ha seleccionado un tamaño para doming");
            return;
          }

          let actualSizeInfo = this.avalibleSizeDoming.find(
            p => p.code == param.domingTamCode
          );

          if (!actualSizeInfo) {
            console.warn("Tamaño doming no valido");
            return;
          }

          let maxCm2Doming = this.maxValidSizeDoming?.cm2 ?? 0;
          if (actualSizeInfo?.value > maxCm2Doming) {
            this.addAlert({
              title:
                this.$t("errores.alert.errorTamEstampacionTitleDialog") +
                " (" +
                this.$t("tecnicas.DOMING") +
                ")",
              listProduct: [],
              code: "errorTamEstampacion",
              // tamEstX: actualSelected.Ancho,
              // tamEstY: actualSelected.Alto,
              zone: this.zona,
              tamEstampacion: actualSizeInfo?.value
            });

            warningTech.push({
              listProduct: [],
              code: "errorTamEstampacion",
              // tamEstX: actualSelected.Ancho,
              // tamEstY: actualSelected.Alto,
              zone: this.zona,
              tamEstampacion: actualSizeInfo?.value
            })
          }

          resultParam.tamanoCm2Doming = param.domingTamCode;
        }

        if (this.isAvalibleNombreaNombre) {
          resultParam.nombreANombre = param.nombreANombre;
        }

        if (this.dimensionLogo3d && this.dimensionLogo3d.height && this.dimensionLogo3d.width) {
          resultParam.logo3dDimensions = JSON.stringify({
            width: this.dimensionLogo3d.width,
            height: this.dimensionLogo3d.height
          });
        }

        if (this.infoTecnicaSeleccionada.tamanoCm2) {
          resultParam.tamanoCm2 = param.tamanoCm2Area;

          if (actualTecnicaValue == "Dtf3d" && resultParam.tamanoCm2 > 50) {
            this.addAlert({
              title:
                this.$t("errores.alert.errorTamEstampacionTitleDialog") +
                " (" +
                this.$t("tecnicas.DTF-3D") +
                ")",
              listProduct: [],
              code: "errorTamEstampacion",
              zone: this.zona,
              tamEstampacion: `${resultParam.tamanoCm2}cm2 (max 50cm2)`
            });
            return;
          }

          if (resultParam.maxHeight || resultParam.maxWidth) {
            console.warn(
              "Sobrescribiendo valores por defecto de height y width por los generados por cm2"
            );
          }

          resultParam.maxHeight = this.heightTamanoCm2;
          resultParam.maxWidth = this.widthTamanoCm2;
        }

        if (this.infoTecnicaSeleccionada.fondoOscuro) {
          resultParam.fondoOscuro = !this.isZoneOnlyBlanco;
        }

        if (this.infoTecnicaSeleccionada.efecto3d) {
          resultParam.efecto3d = !!param.efecto3d;
        }

        if (this.infoTecnicaSeleccionada.typeTermograbado) {
          resultParam.typeTermograbado = param.typeTermograbado;
        }

        if (this.infoTecnicaSeleccionada.isZoneOnlyBlanco) {
          resultParam.isZoneOnlyBlanco = this.isZoneOnlyBlanco;
        }

        resultParam.repeticion = this.activeComercial && this.infoTecnicaSeleccionada.repeticion ? param.esRepeticion : false;

        resultParam.unidadesTotales = this.totalUnidades;

        if (this.isSublimacion) {
          resultParam.unidadesTotales = this.numProductosBlancos;
        }

        let unidades = resultParam.unidadesTotales;

        // Transformamos los parámetros generados, en un string que usaremos para comprobar que se ha modificado algún parámetros, y si se ha modificado, se lo mandaremos a la api para actualizar
        let atr = JSON.stringify([resultParam]);

        if (atr == this.lastAtrb && !noCompareOldParams) return;

        // Llamada a la api para calcular la técnica actual
        try {
          console.log("🚀 ~ warningTech:", warningTech)
          this.cargandoTabZona = true;
          let tecnicaToSend = this.hasGroupedTecnicaSelected
            ? this.specificTecnicaSeleccionadOfGroup
            : this.tecnicaSeleccionada;

          if (tecnicaToSend == "DtfUv") {
            tecnicaToSend = this.seEnvianMetrosLineales
              ? "DtfUvMetrosLineales"
              : "DtfUvStm";
          }

          if (tecnicaToSend == "Dtf3d") {
            tecnicaToSend = "Dtf3dStm";
          }

          await this.calcularPrecios({
            id: this.zona.id,
            tecnica: tecnicaToSend,
            codigo: this.modelInfoFromCatalog.code,
            posicion: this.zona.Posicion,
            zona: this.zona.Zona,
            unidades: unidades,
            isRepeticion: resultParam.repeticion,
            atributos: atr,
            warningTech
          });
          
        } catch (error) {
          if (error != "errorColorBanned") {
            console.error(error);
            alert(this.$t("general.Error al calcular precios"));
          }
        } finally {
          this.lastAtrb = atr;
          this.cargandoTabZona = false;
        }
      
    }
  }
};
</script>

<style lang="scss">

.v-list.v-select-list.v-sheet {
  padding: 0px;
     .color-list {
      &.error-option {
      background: #FFF0F0;
      color: #FF3B30;
     }
    
     &.correct-option {
      background: #ECFFF1;
      color: #34C759;
     }

     &.v-list-item--active {
      border: 2px solid #adadad !important;
      color: #4d4d4d !important;
     } 
     }
  }

.generic-calculadora-parameters {
  a {
    text-decoration: underline;
    font: normal normal bold 12px/15px $heading-font-family;
    letter-spacing: 0px;
    color: #000000 !important;
  }
  .row {
    margin-top: 3px !important;

    .col {
      padding: 6px !important;
      &:first-child {
        padding-left: 12px !important;
      }

      &:last-child {
        padding-right: 12px !important;
      }
    }
  }

  .description-zone {
    color: #282828;
    font-family: $heading-font-family;
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
  }

  .container-actual-design {

    .design-actual-zone {
      color: var(--Color-Grey-600, #787878);
      font-family: $heading-font-family;
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    .container-img-actual-zone {
      .img-actual-zone {
        width: 2.5rem;
        height: 2.5rem;
  
        border-radius: 0.25rem;
        border: 1px solid var(--Color-Grey-600, #787878);
  
        background-color: white;
  
      }
  
      .delete-icon {
        position: relative;
        top: 15px;
        left: 27px;
        z-index: 1000;
        height: fit-content;
        width: fit-content;
        background: #d8d8d8;
        border-radius: 25px;

          &:hover {
            color: var(--v-error-base, red);
          }
        }

    }

  }

  

  .container-check-repeticion {
    padding: 6px !important;
    margin-left: 6px;
  }

  .litle-head-title {
    font: normal normal normal 12px/15px $heading-font-family;
    letter-spacing: 0px;
  }

  .litle-head-alert {
    font: normal normal bold 12px/15px $heading-font-family;
    letter-spacing: 0px;
    margin-bottom: 9px;
  }

  .v-text-field--outlined.v-select {
    background: white !important;
  }

  .custom-input {
    margin: 2px 4px;
    display: flex;
    justify-content: center;
    max-height: 40px;

    .prepend-text {
      background: black;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0px;
      padding: 4px 12px;
      text-transform: capitalize;
      min-height: 100%;
      flex-direction: column;
      min-width: 66px;
      border-radius: 4px 0px 0px 4px;
      font: normal normal 400 14px/18px $heading-font-family;
    }

    .v-input__slot {
      border-radius: 0px 4px 4px 0px;
      max-height: 46px;
    }

    .v-text-field__details {
      // font: normal normal normal 12px/15px $heading-font-family;
    }
  }
}

.v-input--checkbox {
  .v-label {
    font: normal normal normal 12px/15px $heading-font-family;
    letter-spacing: 0px;
  }
}
</style>
